<template>
  <div id="rightBo" ref="rightBo" class="right-body">
    <div ref="rightMiddle" :class="searchResultShow?'right-middle-search':'right-middle'"
      @contextmenu.prevent="preventMenu($event)">
      <div id="navigation" v-show="!searchResultShow" ref="navigation">
        <div class="navigation-path">
          <table>
            <tr>
              <td class="home-page-icon home-icon-position" @click="toHomePage()"></td>
              <td class="icon-util separate_icon separate-icon-position"></td>
              <div style="float:left;line-height:18Px;" id="pathDiv">
                <span :key="index" v-for="(path,index) in pathJson">
                  <td class="icon-util separate_icon separate-icon-position" :id="index" v-if="index"></td>
                  <td :title="path.name"
                    v-bind:class="{'text-bold':index==pathJson.length-1,'name-desc-one':index==0,'name-desc':pathJson.length!=0&&index!=pathJson.length-1&&pathJson.length>1&&path.id!='addEllipsis','add-Ellipsis':path.id=='addEllipsis'}"
                    @click="comeBackFile($event,path,index)">{{path.name|ellipsisNavi}}</td>
                </span>
              </div>
            </tr>
          </table>
        </div>
      </div>
      <!-- 右上菜单键 -->
      <div class="menu-bar" :class="[searchResultShow?'menu-bar-search':'']">
        <div ref="menuButton" class="menu-button" v-if="showMenuButton()">
          <div v-if="!recycleBinShow" style="position:relative;">
            <button class="single-button button-border-left" @click="copyToDialogShow" :style="{width:getWidth()}"
              v-show="showCopyTo()">
              <div class="button-content">
                <div class="button-center-position " :style="{width:getTextWidth(1)}">
                  <div class="more-white-position copy-to icon-position"></div>
                  <div class="cloud-exploer-operating">{{$t('language.common.copyTo')}}</div>
                </div>
              </div>
            </button>
            <button class="single-button button-border" @mouseover="addActive($event)" @mouseout="removeActive($event)"
              @click="downLoadFile()" :style="{width:getWidth()}"
              v-show="showDownLoad()">
              <div class="button-content">
                <div class="button-center-position " :style="{width:getTextWidth(2)}">
                  <div class="more-white-position down-load icon-position"></div>
                  <div class="cloud-exploer-operating">{{$t('language.common.download')}}</div>
                </div>
              </div>
            </button>
            <button @mouseover="addActive($event)" @mouseout="removeActive($event)" class="single-button button-border"
              @click="cutFile()" :style="{width:getWidth()}" v-show="showCutMenu()">
              <div class="button-content">
                <div class="button-center-position" :style="{width:getTextWidth(3)}">
                  <div class="more-white-position cut icon-position"></div>
                  <div class="cloud-exploer-operating ">{{$t('language.common.cut')}}</div>
                </div>
              </div>
            </button>
            <button @mouseover="addActive($event)" @mouseout="removeActive($event)" class="single-button"
            :class="[showCopy()?'button-border':'button-border-left']"
              @click="deleteDialogOpen()" :style="{width:getWidth()}" v-if="showDeleteMenu()">
              <div class="button-content">
                <div class="button-center-position" :style="{width:getTextWidth(4)}">
                  <div class="more-white-position delete icon-position"></div>
                  <div class="cloud-exploer-operating">{{$t('language.common.delete')}}</div>
                </div>
              </div>
            </button>
            <div v-if="!moreShow" style="float:left;">
              <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
                class="single-button button-border" @click="decryptPopupShow()" :style="{width:getWidth()}"
                v-if="suffixArr.includes('multcloud')&&isAllEqual(suffixArr)">
                <div class="button-content">
                  <div class="button-center-position" :style="{width:getTextWidth(9)}">
                    <div class="more-white-position encrypt icon-position"></div>
                    <div class="cloud-exploer-operating">{{$t('language.common.decrypt')}}</div>
                  </div>
                </div>
              </button>
              <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
                class="single-button button-border" @click="editName" :style="{width:getWidth()}"
                v-if="showRenameMenu()">
                <div class="button-content">
                  <div class="button-center-position" :style="{width:getTextWidth(10)}">
                    <div class="more-white-position rename icon-position"></div>
                    <div class="cloud-exploer-operating">{{$t('language.common.rename')}}</div>
                  </div>
                </div>
              </button>
              <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
                class="single-button button-border" @click="readyOpenFile(selectItemArr[0])" :style="{width:getWidth()}"
                v-show="selectItemArr.length==1&&$route.query.folderId != 'root'&&selectItemArr[0].docType&&selectItemArr[0].docType!='FOLDER'">
                <div class="button-content">
                  <div class="button-center-position" :style="{width:getTextWidth(8)}">
                    <div class="more-white-position preview icon-position"></div>
                    <div class="cloud-exploer-operating">{{$t('language.common.preview')}}</div>
                  </div>
                </div>
              </button>
              <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
                class="single-button  button-border" @click="copyFile()" :style="{width:getWidth()}"
                v-show="showCopy()">
                <div class="button-content">
                  <div class="button-center-position" :style="{width:getTextWidth(11)}">
                    <div class="more-white-position copy icon-position"></div>
                    <div class="cloud-exploer-operating">{{$t('language.common.copy')}}</div>
                  </div>
                </div>
              </button>
              <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
                class="single-button" @click="goOfficialSite()" :style="{width:getWidth()}"
                :class="[showCopy()?'button-border':'button-border-left',moreShow?'':'button-border-right']">
                <div class="button-content">
                  <div class="button-center-position" :style="{width:getTextWidth(12)}">
                    <div class="more-white-position to-site icon-position"></div>
                    <div class="cloud-exploer-operating">{{$t('language.common.toOfficialSite')}}</div>
                  </div>
                </div>
              </button>
            </div>
            <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
              class="single-button  button-border button-more button-border-right" v-if="moreShow"
              @click="topRightMenuShow" :style="{width:getWidth()}" v-clickoutside="moreChooseClose">
              <div class="button-content ">
                <div class="button-center-position" :style="{width:getTextWidth(5)}">
                  <div class="more-white-position more more-position"></div>
                  <div class="cloud-exploer-more">{{$t('language.common.more')}}</div>
                </div>
              </div>
              <div class="more-items-choose" v-if="moreChooseShow">
                <div class="more-item-choose" id="sec" v-if="suffixArr.includes('multcloud')&&isAllEqual(suffixArr)">
                  <div class="icon-util item-position encrypt"></div>
                  <div class="menu-txt">{{$t('language.common.decrypt')}}</div>
                </div>
                <div class="more-item-choose" v-if="showRenameMenu()" @click="editName">
                  <div class="icon-util item-position rename"></div>
                  <div class="menu-txt">{{$t('language.common.rename')}}</div>
                </div>
                <div class="more-item-choose" @click="copyFile()" v-if="showTeamMenu()">
                  <div class="icon-util item-position copy"></div>
                  <div class="menu-txt">{{$t('language.common.copy')}}</div>
                </div>
                <div class="more-item-choose" @click="goOfficialSite()">
                  <div class="icon-util item-position to-site"></div>
                  <div class="menu-txt">{{$t('language.common.toOfficialSite')}}</div>
                </div>
              </div>
            </button>
          </div>
          <div v-if="recycleBinShow">
            <button class="single-button more-botton-css" :style="{width:getTrashWidth()}" @click="deleteDialogOpen()">
              <div class="button-content">
                <div class="button-center-position" :style="{width:getTextWidth(6)}">
                  <div class="icon-util  delete icon-position" style="top:3Px;margin-right:5Px;"></div>
                  <div class="cloud-exploer-operating">{{$t('language.cloudExploer.deleteForever')}}</div>
                </div>
              </div>
            </button>
            <button @mouseover="addActive($event)" @mouseout="removeActive($event)"
              class="single-button button-border button-border-right" @click="RestoreFile()"
              :style="{width:getTrashWidth()}">
              <div class="button-content">
                <div class="button-center-position" :style="{width:getTextWidth(7)}">
                  <div class="icon-util to-site icon-position" style="margin-right:4Px;top:3Px;"></div>
                  <div class="cloud-exploer-operating">{{$t('language.cloudExploer.restore')}}</div>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div v-show="searchResultShow">
          <span>
            <td class="search-back" style="line-height:20px;/*no*/" @click="backSearch()">
              {{$t('language.cloudExploer.back')}}
            </td>
          </span>
          <td class="icon-util separate_icon separate_icon-position"></td>
          <span>
            <td class="text-bold" style="line-height:20px;/*no*/">
              {{$t('language.cloudExploer.searchResult')}}
            </td>
          </span>
        </div>
        <!-- 未选中任何选项时出现的菜单 -->
        <div class="item-button" v-if="itemButtonShow()" :class="isflage?'':'right-body-disable'">
          <div v-if="!recycleBinShow&&$route.query.folderId != 'recycle_bin'">
            <div style="float:left;position:relative;" v-clickoutside="handleSelectClose"
              @mouseover="uploadFileItemShow=true" @mouseleave="uploadFileItemShow=false">
              <div class="upload-file" v-if="showUploadFile()">
                <div class="upload" style="float:left;"></div>
                <input type="file" id="openFile" ref="uploadFile" @change="clickUploadFileChange($event)"
                  multiple="multiple" />
                <div :class="[onlyShowRemote?'upload-item':'upload-item-dis']" @click="openFileDialog">
                  {{$t('language.cloudExploer.uploadFile')}}
                </div>
                <div @click="dropDownValueShow" v-if="onlyShowRemote()" class="icon-util dropdown-position"
                  :class="dropDownName"></div>
                <div v-if="showUploadFile()&&!onlyShowRemote()" style="width: 12px;float: left;"></div>
              </div>
              <div class="upload-file" v-if="onlyShowRemote()&&!showUploadFile()">
                <span class="folder-item" @click="linkTaskOpen()">{{$t('language.common.btLink')}}</span>
              </div>
              <div class="upload-file-items-choose" v-show="uploadFileItemShow&&onlyShowRemote()&&showUploadFile()">
                <input type="file" id="openFolder" style="display:none" webkitdirectory />
                <div class="upload-file-item-choose" @click="linkTaskOpen()" :title="$t('language.common.btLink')">
                  {{$t('language.common.btLink')}}
                </div>
              </div>
            </div>
            <div class="new-folder" v-if="showNewFolder()">
              <div class="plus add-plus-position" style="float:left;margin-right:5Px;position:relative;top:3Px;"></div>
              <span :class="isflage ? 'folder-item' : 'folder-item-not'" @click="newFolder()">{{
                $t('language.cloudExploer.newFolder') }}</span>
            </div>
            <div class="new-folder"
              v-if="($store.state.copyArr.length||$store.state.cutClonArr.length)&&showPasteMenu()">
              <div class=" paste left-paste-position" style="float:left;"></div>
              <span class="folder-item up-paste-position  cloud-paste-position"
                @click.stop="pasteFile()">{{$t('language.common.paste')}}</span>
            </div>
            <div
              :class="$route.query.cloudType == 'gSuite' && $route.query.folderId == '/'?'new-folder-dis':'new-folder'"
              v-if="trashArr.includes($route.query.cloudType)">
              <div class=" delete" style="float:left;margin-left:3Px;"></div>
              <span style="float:left;" class="folder-item up-paste-position"
                @click="goTrash()">{{$t('language.cloudExploer.trash')}}</span>
            </div>
          </div>
          <div class="upload-file" v-if="showEmptyTrash()">
            <div class=" delete" style="float:left;"></div>
            <span class="folder-item up-paste-position" @click="emptyTrash()"
              style="cursor:pointer">{{$t('language.cloudExploer.emptyTrash')}}</span>
          </div>
        </div>
        <div class="operate-icons">
          <div :data-title="$t('language.cloudExploer.reFresh')" v-if="!searchResultShow"
            class=" refresh cloud-exploer-refresh   refresh-position" @click="reFresh()"></div>
        </div>
      </div>
    </div>
    <div :class="searchResultShow?'right-search-body':'right-cont-body'" @contextmenu.prevent="preventMenu($event)">
      <!-- contextmenu.prevent右键事件，.prevent阻止默认事件 -->
      <div class="table-box" id="dropTableBox" v-show="$route.query.docType!=='thread'" @contextmenu.prevent="rightBlankMenuOpen($event)">
        <div id="tableBoxTitle">
          <table border="0" cellpadding="0" cellspacing="0" style="width:100%;height:auto;">
            <tr class="table-th" style="cursor: context-menu;">
              <td :class="pathJson.length>1?'cloud-td-twoDiv':''" style="width:25%">
                <div :class="!searchResultShow?'tr-check-box':'tr-check-search'"
                  @click.stop="clickBoxAddAllTableToggle()">
                  <div v-if="!searchResultShow" class="icon-util  icon-tr-position "
                    :class="selectItemArr.length==tableData.length&&selectItemArr.length>0?'check-small':' nocheck-small'">
                  </div>
                </div>
                <div v-if="$route.query.cloudType=='gmail'">
                  <span class="th-span" style="line-height:40Px;" v-if="pathJson.length<2">{{$t('language.emailExploer.email')}}</span>
                  <span class="th-span" style="line-height:40Px;" v-else>
                    <span v-if="$route.query.folderId=='category:Sent'||$route.query.folderId=='category:Drafts'">{{$t('language.emailExploer.to')}}</span>
                    <span v-else>{{$t('language.emailExploer.from')}}</span>
                  </span>
                </div>
                <div v-if="$route.query.cloudType=='outlook'">
                  <span class="th-span" style="line-height:40Px;">{{$t('language.common.selectAll')}}</span>
                </div>
              </td>
              <td class="cloud-td-oneDiv" style="line-height:40Px;width:59%;" v-if="pathJson.length>1&&$route.query.cloudType=='gmail'">
                <span>{{$t('language.emailExploer.subject')}}</span>
              </td>
              <td class="cloud-td-twoDiv" style="line-height:40Px;" v-if="pathJson.length>1&&$route.query.cloudType=='gmail'">
                <span v-if="$route.query.folderId=='category:Sent'">{{$t('language.emailExploer.sentTime')}}</span>
                <span v-if="$route.query.folderId=='category:Drafts'">{{$t('language.common.dateModified')}}</span>
                <span v-if="$route.query.folderId!='category:Drafts'&&$route.query.folderId!='category:Sent'">{{$t('language.emailExploer.received')}}</span>
              </td>
            </tr>
          </table>
        </div>
        <div id="tableBox" ref='boxStyle' v-loading="loading">
          <!-- contextmenu.prevent右键事件，.prevent阻止默认事件 -->
          <el-scrollbar style='height:100%;' ref="elscrollbar">
            <!-- <table border="0" cellpadding="0" v-infinite-scroll="loadTableData" infinite-scroll-delay=0 cellspacing="0" -->
            <table border="0" cellpadding="0" infinite-scroll-delay=0 cellspacing="0"
              style="width:100%;height:auto;table-layout: fixed;">
              <!-- <div class="selection"></div> -->
              <tr class="table-tr selectable"
                :class="[selectItemArr.includes(item)?'tr-back-ground':'',tableHoverItem==item?'table-tr-hover':'']"
                :key="index" v-for="(item,index) in nowTableData" @mouseout="tableHoverItem=null"
                @mouseover="tableHoverItem=item" @contextmenu.prevent="clickRightMenuShow($event,item,index)"
                @dblclick.prevent="readyOpenFile(item),rightMenuShow = false;" 
                @click.stop="clickCheckSingleItem(item,index,$event),closeAllMenu()" @click.shift="multipleBox(index)">
                <div :class="pathJson.length>1?'cloud-td-twoDiv':''" ref="tdOne" style="width:25%;" >
                  <div :class="!searchResultShow?'tr-check-box':'tr-check-search'" @dblclick.stop=""
                    @click.stop.exact="clickBoxAddTableCheck(item,index)" @click.shift="multipleBox(index)">
                    <div v-show="!searchResultShow" class="icon-util icon-tr-position"
                      :class="selectItemArr.includes(item)?'check-small ':'nocheck-small '"></div>
                  </div>
                  <div v-if="pathJson.length<2||(item.dir&&!item.docType)||(item.dir&&$route.query.cloudType=='outlook'&&item.docType=='FOLDER')">
                    <div class="small-file tr-file-position" :class="item.dir?'folder':matchfileType(item.name)"></div>
                    <!-- <div class="small-file tr-file-position" :class="item.dir?'folder-not':matchfileType(item.name)"></div> -->
                  </div>
                  <div :class="!searchResultShow?'cloud-file-name':'cloud-file-name-not'" id="fileName">
                    <div v-if="pathJson.length>1&&(item.dir&&item.docType=='thread')">
                      <div class="name-edit-div" v-if="$route.query.folderId=='category:Sent'||$route.query.folderId=='category:Drafts'" ref="listName" 
                        :title="item.to" @click.stop="readyOpenFile(item),closeAllMenu()" :style="$route.query.folderId=='category:Drafts'?'color:#FF1B46;':''">{{item.to|fromFilter}}</div>
                      <div class="name-edit-div" v-else ref="listName" :title="item.from" @click.stop="readyOpenFile(item),closeAllMenu()">{{emailsFilter(item.from,item.cloudEmailAddress)}}</div>
                    </div>
                    <div v-else>
                      <div class="name-edit-div"  ref="listName" :title="item.name" @click.stop="readyOpenFile(item),closeAllMenu()">{{item.name}}</div>
                    </div>
                    <div :class="isflage ? 'cloud-outclass' : 'cloud-outclass-not'" ref="listInputName">
                      <input class="name-edit-input" v-model="item.inputValue" @focus="onfocusEvent"
                        @blur="submitName(item, index)" @keyup.enter="$event.target.blur" />
                      <div class="cloud_edit_icon">
                        <div class="icon-util name-sure" @click.stop="submitName(item, index)"></div>
                        <div class="icon-util name-cancel name-cancel-position"
                          @mousedown.stop="cancelEditName(item, index)"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cloud-td-oneDiv subject-tip" style="width:57%;" v-if="pathJson.length>1&&(item.dir&&item.docType=='thread')">{{item.subject}}<span v-if="item.snippet" v-html="' - '+item.snippet"></span></div>
                <div class="cloud-td-twoDiv" v-if="pathJson.length>1&&(item.dir&&item.docType=='thread')">
                  <span v-if="$route.query.cloudType=='outlook'">{{item.date|transferTime}}</span>
                  <span v-else>{{item.date}}</span>
                </div>
              </tr>
              <div class="load-tr" v-if="listPageLoading">{{$t('language.cloudExploer.loading')}}</div>
              <div class="load-tr" v-if="noMore">{{$t('language.cloudExploer.dataLoaded')}}</div>
              <div class="load-tr" v-if="nextLoading&&$route.query.folderId != 'root'" ><img src="../../assets/images/icon_list_loading.gif"></div>
            </table>
          </el-scrollbar>
          <div class="exploer-notice" v-if="emptyNoticeShow&&$route.query.folderId != 'recycle_bin'&&!searchResultShow">
            {{$t('language.cloudExploer.emptyNotice')}}
          </div>
          <div class="exploer-notice" v-if="emptyNoticeShow&&$route.query.folderId == 'recycle_bin'">
            {{$t('language.cloudExploer.trashEmpty')}}
          </div>
          <div class="exploer-notice" v-if="emptyNoticeShow&&searchResultShow">
            {{$t('language.cloudExploer.searchEmpty')}}
          </div>
        </div>
      </div>
      <div class="table-box" id="previewTableBox" v-if="$route.query.docType=='thread'" v-loading="loading">
        <previewPage ref="previewPage" :thread="$route.query" :emails="tableData"></previewPage>
      </div>
      <!-- 右键空白区域显示菜单 -->
      <div class="blank-menus-choose" v-if="rightBlankMenuShow" id="rightBlankMenu"
        v-clickoutside="rightBlankMenuClose">
        <!-- <div class="more-item-choose" @click="openFileDialog" v-if="showUploadFile()">
          <input type="file" id="openFile" style="display:none" ref='uploadFile' />
          <div class="preview-position item-position upload"></div>
          <div class="menu-txt">{{$t('language.cloudExploer.uploadFile')}}</div>
        </div> -->
        <div class="more-item-choose" @click="linkTaskOpen()" v-if="onlyShowRemote()">
          <div class="preview-position remote item-position" style="top:6Px !important;margin-right:16Px !important;">
          </div>
          <div class="menu-txt">{{$t('language.common.btLinkTask')}}</div>
        </div>
        <div class="more-item-choose" @click="newFolder()" v-if="showNewFolder()">
          <div class="preview-position plus item-position"></div>
          <div class="menu-txt" style="margin-left:1Px;">{{ $t('language.cloudExploer.newFolder') }}</div>
        </div>
        <div class="more-item-choose"
          v-if="($store.state.copyArr.length||$store.state.cutClonArr.length)&&$route.query.folderId != 'recycle_bin'&&showPasteMenu()"
          @click="pasteFile()">
          <div class="preview-position item-position paste" style="margin-left:3Px;"></div>
          <div class="menu-txt">{{$t('language.common.paste')}}</div>
        </div>
        <div class="more-item-choose"
          v-if="trashArr.includes($route.query.cloudType)&&$route.query.folderId != 'recycle_bin'" @click="goTrash()">
          <div class="preview-position item-position delete" style="margin-left:1Px;"></div>
          <div class="menu-txt">{{$t('language.cloudExploer.trash')}}</div>
        </div>
        <div class="more-item-choose"
          v-if="$route.query.folderId == 'recycle_bin'&&$route.query.cloudType=='google_drive'" @click="emptyTrash()">
          <div class="preview-position item-position delete"></div>
          <div class="menu-txt">{{$t('language.cloudExploer.emptyTrash')}}</div>
        </div>
      </div>
      <!-- 右键某个item显示菜单 整个大菜单-->
      <div class="right-menus-choose" v-if="showSelectRightMenu()" id="rightMenu" v-clickoutside="rightMenuClose">
        <!-- more-item-choose某一项菜单 每一项对应一个点击事件 -->
        <div class="more-item-choose" @click="downLoadFile()" v-show="showDownLoad()">
          <div class="down-load item-position preview-position"></div>
          <div class="menu-txt">{{$t('language.common.download')}}</div>
        </div>
        <!-- 多选时显示的右键菜单 -->
        <div class="more-item-choose" id="moreItem" v-if="suffixArr.includes('multcloud')&&isAllEqual(suffixArr)"
          @click="decryptPopupShow()">
          <div class=" item-position encrypt preview-position"></div>
          <div class="menu-txt">{{$t('language.common.decrypt')}}</div>
        </div>
        <div class="more-item-choose" v-if="showRenameMenu()" @click="editName()">
          <div class=" item-position rename preview-position"></div>
          <div class="menu-txt">{{$t('language.common.rename')}}</div>
        </div>
        <div class="more-item-choose" @click="copyToDialogShow()" v-if="showTeamMenu()">
          <div class="preview-position item-position copy-to"></div>
          <div class="menu-txt">{{$t('language.common.copyTo')}}</div>
        </div>
        <div class="more-item-choose" @click="cutFile()" v-if="showCutMenu()">
          <div class="preview-position item-position cut"></div>
          <div class="menu-txt">{{$t('language.common.cut')}}</div>
        </div>
        <div class="more-item-choose" @click="copyFile()" v-if="showTeamMenu()">
          <div class="preview-position item-position copy"></div>
          <div class="menu-txt">{{$t('language.common.copy')}}</div>
        </div>
        <div class="more-item-choose"
          v-if="($store.state.copyArr.length||$store.state.cutClonArr.length)&&$route.query.folderId != 'recycle_bin'&&showPasteMenu()"
          @click="pasteFile()">
          <div class="preview-position item-position paste"></div>
          <div class="menu-txt">{{$t('language.common.paste')}}</div>
        </div>
        <div class="more-item-choose" @click="goOfficialSite()">
          <div class="preview-position item-position to-site"></div>
          <div class="menu-txt">{{$t('language.common.toOfficialSite')}}</div>
        </div>
        <div class="more-item-choose" @click="deleteDialogOpen()" v-if="showDeleteMenu()">
          <div class="preview-position item-position delete"></div>
          <div class="menu-txt">{{$t('language.common.delete')}}</div>
        </div>
      </div>
      <!-- 右键菜单1 -->
      <div class="right-menus-choose" id='searchMenu' v-if="searchMenuShow" v-clickoutside="searchMenuClose">
        <div class="more-item-choose" @click="jumpTo()">
          <div class="preview-position item-position to-site"></div>
          <div>{{$t('language.cloudExploer.jumpTo')}}</div>
        </div>
      </div>
      <!-- 右键菜单2 -->
      <div class="right-menus-choose" id='recycleMenu' v-if="recycleMenuShow" v-clickoutside="recycleMenuClose">
        <div class="more-item-choose" @click="deleteDialogOpen()">
          <div class="preview-position item-position delete"></div>
          <div style="float:left;">{{$t('language.cloudExploer.deleteForever')}}</div>
        </div>
        <div class="more-item-choose" @click="RestoreFile()">
          <div class="preview-position item-position to-site"></div>
          <div style="float:left;">{{$t('language.cloudExploer.restore')}}</div>
        </div>
      </div>
      <div class="selectInfo-footer" v-show="!searchResultShow&&$route.query.docType!='thread'">
        <div class="select-Info">{{selectItemArr.length}}/{{tableData.length}} {{$t('language.common.itemsSelected')}}
        </div>
        <!-- <div class="select-Info">{{selectItemArr|getAllBytes|formatByte}}/{{tableData|getAllBytes|formatByte}}</div> -->
        <div class="icon scaling-open scaling-open-position" v-show="snapTaskIconShow" @click="snapTasksOpen()">
          <snapTaskDialog ref="snapTaskDialog" @cancel='cancelUpload($event)'></snapTaskDialog>
        </div>
      </div>
    </div>
    <deleteDialog ref="deleteDialog"></deleteDialog>
    <copyToDialog ref="copyToDialog"></copyToDialog>
    <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
    <retryFailedDialog ref="retryFailedDialog"></retryFailedDialog>
    <linkTaskDialog ref="linkTaskDialog"></linkTaskDialog>
    <uploadToTreeDialog ref="uploadToTreeDialog"></uploadToTreeDialog>
    <fileExistDialog ref="fileExistDialog"></fileExistDialog>
    <cancelAllDialog ref="cancelAllDialog"></cancelAllDialog>
    <upgradeDialog ref="upgradeDialog"></upgradeDialog>
    <decryptDialog ref="decryptDialog"></decryptDialog>
    <parseTipsDialog ref="parseTipsDialog"></parseTipsDialog>
    <subfileSelectDialog ref="subfileSelectDialog"></subfileSelectDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
    <downloadDialog ref="downloadDialog"></downloadDialog>
  </div>
</template>

<script>
  //显示账号升级弹窗
  import upgradeDialog from "@/components/popup/upgrade_popups/upgrade_account_popup";
  import decryptDialog from "@/components/popup/cloud_exploer_popups/decrypt_popup";
  import fileExistDialog from '@/components/popup/cloud_exploer_popups/file_exist_popup.vue';
  import cancelAllDialog from '@/components/popup/cloud_exploer_popups/cancel_all_popup.vue';
  import uploadToTreeDialog from '@/components/popup/remote_task_popups/upload_to_tree_popup';
  import linkTaskDialog from '@/components/popup/remote_task_popups/add_link_task_popup';
  import subfileSelectDialog from '@/components/popup/remote_task_popups/subfile_select_popup';
  import parseTipsDialog from '@/components/popup/remote_task_popups/parse_tips';
  import searchDialog from "@/components/popup/cloud_exploer_popups/search_popup";
  import deleteDialog from "@/components/popup/cloud_exploer_popups/delete_popup";
  import copyToDialog from "@/components/popup/cloud_exploer_popups/copy_to_popup";
  import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
  import snapTaskDialog from "@/components/popup/cloud_exploer_popups/snap_task_popup";
  import retryFailedDialog from "@/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup";
  import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
  import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
  import commonUtils from "@/js/workspace/common_util.js";
  import commonstate from '@/js/constant.js';
  import requestUtils from '@/js/request_util.js';
  import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
  import '@/assets/css/table.css';
  import common_util from '../../js/workspace/common_util';
  import previewPage from './thread_preview';
  import downloadDialog from "@/components/popup/email_exploer_popups/download_thread_popup";
  export default {
    data() {
      return {
        tableData: [], //当前页面的数据
        dropDownName: "dropdown-purple",
        uploadFileItemShow: false,
        moreChooseShow: false,
        shareChooseShow: false, //分享用
        shareRightMenuShow: false, //分享用
        rightMenuShow: false,
        rightBlankMenuShow: false,
        selectIsFile: false,
        selectItemArr: [],
        oldNameValue: "",
        navigationPathShow: false,
        pathJson: [],
        loading: false,
        isflage: true,
        snapTaskIconShow: false,
        currentIndex: -1,
        filesArr: null,
        pasteFlag: false,
        gridHoverIndex: -1,
        gridClickIndex: -1,
        cancelFlag: false,
        tableHoverItem: null,
        renameItem: null,
        openFileFlag: true,
        trashArr: ['box', 'google_drive', 'gSuite','iCloudDrive'],
        searchResultShow: false, //是否为搜索结果
        searchMenuShow: false,
        searching: false,
        recycleBinShow: false, //标志是否为回收站结果数据
        recycleMenuShow: false,
        itemDecrypt: false,
        suffixArr: [],
        reName: null,
        offset: '',
        nextPage: '',
        oldPage: '',
        limit: 200,
        key: true,
        cloudrootArr: ['dropbox4Business', 'googlePhotos', 'sharePointOnline', 41],
        emptyNoticeShow: false,
        firstIndex: -1,
        upShow: false,
        index: 4,
        newFolderItem: '',
        newFolderIndex: -1,
        retryItems: [],
        listPageLoading: false,
        noMore: false,
        selectable: false,
        oBox: null, //定义画出矩形
        ev: null,
        oDiv: null,
        x1: null,
        y1: null,
        x2: null,
        y2: null,
        left: null,
        top: null,
        width: null,
        height: null,
        uploadFlag: true,
        onLine: navigator.onLine,
        checkFlag: true, //用于用户选中数据
        moreShow: false, //不支持跳转到云盘网站的云盘
        nowTableData: [], //防止页面数据过多，只能让其渲染的数据
        pNodeLength: 0, //通过pnode长度算目录长度
        datafirstIndex: 0,
        endIndex: 200,
        startPage: 0, //用于表示开始选中的那个页面
        docType: "",//文件夹类型
        listShow:true,//默认文件列表
        nextLoading: false,//是否显示下一页loading状态
        isNextLoading: false,//是否允许显示下一页loading状态
      };
    },
    inject: ["reload"],
    components: {
      searchDialog,
      deleteDialog,
      copyToDialog,
      snapTaskDialog,
      detailedProgrssDialog,
      retryFailedDialog,
      linkTaskDialog,
      uploadToTreeDialog,
      fileExistDialog,
      cancelAllDialog,
      upgradeDialog,
      decryptDialog,
      parseTipsDialog,
      subfileSelectDialog,
      remindBindEmailDialog,
      previewPage,
      downloadDialog,
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问组件实例，到云盘管理界面的时候
        if (from.name == 'preview') { //如果是从预览界面返回的则恢复显示原来的分页数据
          if (vm.$store.state.datafirstIndex && vm.$store.state.endIndex) {
            vm.datafirstIndex = vm.$store.state.datafirstIndex;
            vm.endIndex = vm.$store.state.endIndex;
            vm.nowTableData = vm.tableData.slice(vm.datafirstIndex, vm.endIndex);
            vm.$store.state.datafirstIndex = 0;
            vm.$store.state.endIndex = 0;
          }
        }
      })
    },
    watch: {
      //监听防止路径丢失
      pathJson(newValue, oldValue) {
        if (!newValue.length) {
          this.getPathJson();
        }
      },
      //监听路由变化并初始化数据
      $route(to, from) {
        let cloudType = this.$route.query.cloudType;
        if(cloudType&&!commonstate.emailClouds.includes(cloudType)) {
          //如果是云盘
          this.$router.push({
            name: "cloudExploer",
            query: {
              cloudType: this.$route.query.cloudType,
              folderId: this.$route.query.folderId,
              folderName: this.$route.query.folderName,
              tokenId: this.$route.query.tokenId,
            }
          });
          return;
        }
        let that = this;
        let div;
        this.$forceUpdate();
        this.checkFlag = true;
        this.isflage = true;
        this.count = 200;
        this.endIndex = 200;
        if (!this.$refs.detailedProgrss) {
          return;
        }
        this.$refs.detailedProgrss.detailedProgressShow = this.$store.state.detaleProgressShow;
        this.selectItemArr = [];
        this.rightMenuShow = false;
        div = this.$refs.elscrollbar.$refs.wrap;
        //将滚动条置为0
        div.scrollTop = 3;
        this.openFileFlag = true;
        this.listPageLoading = false;
        this.noMore = false;
        //如果是正常的云盘界面
        if (this.$route.query.folderId != null && this.$route.query.folderId != 'recycle_bin') {
          this.JudgeReacquireData();
        }
        //如果是查找结果，初始化查找结果数据
        if (this.$route.query.searchResult) {
          this.initSearchData();
        }
        //如果是回收站，初始化回收站数据
        if (this.$route.query.folderId == 'recycle_bin') {
          this.initTrashData();
        }
      },
      //监听界面数据变化
      tableData(newValue, oldValue) {
        let that = this;
        //给每条数据赋值属于哪个云盘，赋值云盘信息
        // $.each(newValue, function(i, item) {
        //   if (that.$store.state.listData && that.$store.state.listData.cloud) {
        //     item.cloud = that.$store.state.listData.cloud;
        //   }
        // });
        // if (newValue.length >= 200) {
        //   this.nowTableData = newValue.slice(0, 200);
        //   this.endIndex = 200;
        //   this.datafirstIndex = 0;
        // } else {
        //   this.nowTableData = newValue;
        // }
        //页面内容改变时，自动关闭下一页loading状态
        this.nextLoading = false;
        
        this.nowTableData = newValue;
        if (!newValue.length && !this.loading) {
          this.emptyNoticeShow = true;
        } else {
          this.emptyNoticeShow = false;
        }
      },
      //监听临时任务数据
      '$store.state.listRuningData': function(newValue, oldValue) {
        let that = this;
        // //若有临时任务，则跳转到其目标目录界面
        if (that.$store.state.listRuningData.length) {
          that.pathJson = [];
          let snapData = that.$store.state.listRuningData[0];
          if (snapData.desCloudType == 'team') {
            return;
          }
          let pathData = that.$store.state.pathJson[snapData.desId + snapData.desToken];
          let nodes = snapData.desNode;
          if (!pathData) {
            for (let i = nodes.length - 1; i >= 0; i--) {
              let name = nodes[i].filename;
              that.pathJson.push({
                id: nodes[i].fileId,
                name: name,
                driveId: snapData.desToken
              });
              let JsonList = Object.assign([], that.pathJson);
              that.$store.commit("setPathJson", {
                folderId: nodes[i].fileId + snapData.desToken,
                json: JsonList
              });
            }
          }
          that.$router.push({
            name: "emailExploer",
            query: {
              cloudType: snapData.desCloudType,
              folderId: snapData.desId,
              folderName: snapData.desFilename,
              tokenId: snapData.desToken,
              docType: snapData.docType,
              queryParameter: snapData.queryParameter
            }
          });
        }
      },
      //监听缓存中右侧待执行临时任务列表数据
      '$store.state.retryItems': function(newValue, oldValue) {
        let snapData = this.$store.state.retryItems;
        let uploadArr = Object.assign([], this.$store.state.uploadArr);
        //右侧待执行临时任务列表数据，是临时任务加上传数据
        this.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
        this.retryItems = this.$refs.snapTaskDialog.items;
      },
      //监听上传列表数据
      '$store.state.uploadArr': function(newValue, oldValue) {
        let snapData = this.$store.state.retryItems;
        let uploadArr = Object.assign([], this.$store.state.uploadArr);
        this.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
        //如果上传列表数据和临时任务待执行列表长度都是0，则不显示临时任务弹窗
        if (newValue.length == 0 && this.$refs.snapTaskDialog.items.length == 0 && this.$store.state
          .detailedProgrssData.length == 0) {
          let t = setTimeout(() => {
            this.snapTaskIconShow = false;
            this.$store.state.snapTaskShow = false;
            clearTimeout(t);
          }, 1000);
        }
      },
      //监听右侧待执行临时任务列表+上传列表总和数据
      retryItems: function(newValue, oldValue) {
        let that = this;
        let key = this.$route.query.folderId + this.$route.query.tokenId;
        let tableData = this.$store.state.cacheTableDatas[key];
        //若是剪切，则一结束就刷新界面
        if (tableData && tableData.id == key) {
          this.docType = tableData.docType;
          this.loading = false;
          this.tableData = tableData.tableData;
          this.nextPage = tableData.nextPage;
          //判断是否有从其他界面跳转过来的选中数据
          this.$nextTick(function() {
            commonUtils.ifHasDataSelect(this);
          });
        }
        if (!newValue.length) {
          that.$store.state.loadFlag = true;
          this.$store.commit("setSourceItems", []);
          this.selectItemArr = [];
        }
      },
      //用于判断是否有添加新的临时任务数据
      '$store.state.haveNewSnapData': function(newValue, oldValue) {
        let that = this;
        //触发事件后，判断是否获取进度
        if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度，则此时获取进度
          commonUtils.runDetailProgressData(that);
        }
      },
      //监听临时任务并将新的数据放在第一页
      '$store.state.detailedProgrssData': function(newValue, oldValue) {
        let that = this;
        this.$refs.detailedProgrss.$refs.tab1.taskDatas = newValue;
      },
      //监听选中的数据
      selectItemArr(newValue, oldValue) {
        if (!newValue.length) {
          this.$refs.deleteDialog.deleteShow = false;
        }
        if (newValue.length) {
          let that = this;
          that.suffixArr = [];
          if (this.selectItemArr.length) {
            that.moreShow = false;
            this.$nextTick(() => {
              that.checkBoxWidth();
            });
          }
        }
      },
      '$store.state.cacheTableDatas': function(newValue, oldValue) {
        let that = this;
      },
    },
    created() {
      //初始化界面数据
      this.tableData = [];
      if (this.$route.query.folderId != null && this.$route.query.folderId != 'recycle_bin') {
        this.JudgeReacquireData();
      }
    },
    mounted() {
      this.scrollbar(); //el-scrollbar触底事件
      this.$forceUpdate();
      let that = this;
      // let user = commonUtils.getUser();
      //进入界面初始化拖拽上传功能
      // var dropbox = document.getElementById('rightBo');
      // if (!dropbox) {
      //   return;
      // }
      // dropbox.addEventListener('dragenter', this.onDrag, false);
      // dropbox.addEventListener('dragover', this.onDrag, false);
      // dropbox.addEventListener('drop', this.onDrop, false);
      addEventListener("keydown", this.keyDown, false);
      addEventListener("keyup", this.keyUp, false);
      this.$refs.detailedProgrss.detailedProgressShow = this.$store.state.detaleProgressShow;
      this.$nextTick(() => {
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
          //浏览器变化执行动作
          if (that.selectItemArr.length) {
            that.moreShow = false;
            this.$nextTick(() => {
              that.checkBoxWidth();
            });
          }
          this.$nextTick(() => {
            that.getPathJson();
          });

        });
        // window.addEventListener('scroll', this.handleScroll, true);
      })
      this.searchResultShow = false;
      this.checkFlag = true;
      //初始化搜索结果
      if (this.$route.query.searchResult) {
        this.initSearchData();
      }
      //初始化回收站数据
      if (this.$route.query.folderId == 'recycle_bin') {
        this.initTrashData();
      }
      // 离线任务跳转过来需更新数据
      if (this.$route.query.offlineRequest) {
        this.reFresh()
      }
      //初始化临时任务数据
      commonUtils.mountedDetailData(that);
    },
    beforeDestroy() { //解绑
      removeEventListener("keydown", this.keyDown);
      removeEventListener("keyup", this.keyUp);
    },
    methods: {
      scrollbar() {
        this.$refs.elscrollbar.handleScroll = () => {
          var wrap = this.$refs.elscrollbar.wrap;
          this.$refs.elscrollbar.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
          this.$refs.elscrollbar.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
          let poor = wrap.scrollHeight - wrap.clientHeight;
          if (
            poor == parseInt(wrap.scrollTop) ||
            poor == Math.ceil(wrap.scrollTop) ||
            poor == Math.floor(wrap.scrollTop)
          ) {
            //如果具备下一页参数
            //至少需要高度高于页面高度
            if(this.$refs.boxStyle.clientHeight&&wrap.scrollHeight>this.$refs.boxStyle.clientHeight){
              if(this.nextPage&&this.isNextLoading&&!this.nextLoading&&(this.$route.query.docType=='category'||this.$route.query.cloudType=='outlook')){
                this.isNextLoading = false;
                this.nextFileData();
              }
            }
          }else{
            this.isNextLoading = true;
          }
        };
      },
      // 为了禁止shift时选中表格内文字
      keyDown(event) {
        let key = event.keyCode;
        if (key == 16) {
          document.getElementById('tableBox').style.userSelect = 'none';
        }
      },
      keyUp(event) {
        let key = event.keyCode;
        if (key == 16) {
          document.getElementById('tableBox').style.userSelect = 'text';
        }
      },
      getPnodeLength(item) {
        if (item.pnode) {
          this.pNodeLength = this.pNodeLength + 1;
          this.getPnodeLength(item.pnode);
        } else {
          return this.pNodeLength;
        }
      }, //滚动条向下加载
      // loadTableData() {
      //   let firstIndex;
      //   let endIndex;
      //   let div;
      //   let that = this;
      //   div = this.$refs.elscrollbar.$refs.wrap;
      //   if (this.tableData.length > 200) { //如果任务大于200条则分页显示
      //     if (this.endIndex < this.tableData.length) {
      //       if (this.endIndex + 200 <= this.tableData.length) { //如果末尾指针+200小于等于界面数据长度
      //         this.datafirstIndex = this.endIndex; //每次都显示200条数据
      //         this.endIndex = this.datafirstIndex + 200;
      //         div.scrollTop = 3;
      //       }
      //       if ((this.endIndex + 200) > this.tableData.length) { //如果末尾指针+200大于界面数据长度
      //         this.endIndex = this.tableData.length; //则末尾指针为末尾数据长度
      //       }
      //       this.nowTableData = this.tableData.slice(this.datafirstIndex, this.endIndex);
      //     }
      //   } else { //如果任务小于等于200条则直接显示
      //     this.nowTableData = this.tableData.slice(0, this.tableData.length);
      //   }
      // }, //滚动条向上加载
      // handleScroll() {
      //   let that = this;
      //   let scrollTopValue;
      //   let div;
      //   //获取滚动距顶部的距离，显示
      //   if (this.$refs.elscrollbar) {
      //       div = this.$refs.elscrollbar.$refs.wrap;
      //     }
      //   if (div) {
      //     if (div.scrollTop != undefined) {
      //       scrollTopValue = div.scrollTop;
      //       if (scrollTopValue == 0) { //如果滚动条滑到顶部
      //         if (this.endIndex > 200) { //则显示上一页数据
      //           if (this.datafirstIndex - 200 >= 0) {
      //             this.datafirstIndex = this.datafirstIndex - 200; //每次都显示200条数据
      //             this.endIndex = this.endIndex - 200;
      //             let t = setTimeout(() => {
      //               that.nowTableData = that.tableData.slice(that.datafirstIndex, that.endIndex);
      //               div.scrollTop = div.scrollHeight - 589;
      //               clearTimeout(t);
      //             }, 100);
      //           }
      //         }
      //       }

      //     }
      //   }

      // },
      //判断数组内的值是否都相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function(value, index) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },
      //显示解密弹窗
      decryptPopupShow() {
        this.$refs.decryptDialog.decryptShow = true;
        this.rightMenuShow = false;
      },
      //按住shift键多选
      multipleBox(index) {
        let allData = Object.assign([], this.tableData);
        //shift多选也应该考虑到分页的情况
        //1.在不分页的情况下
        if (this.tableData.length <= 200) {
          if (this.firstIndex != -1) {
            if (this.firstIndex <= index) {
              this.selectItemArr = this.tableData.slice(this.firstIndex, index + 1);
            } else {
              this.selectItemArr = this.tableData.slice(index, this.firstIndex + 1);
            }
          }
        } else {
          if (this.firstIndex != -1) {
            let firstIndex = (this.startPage * 200) + this.firstIndex;
            let endindex = this.datafirstIndex + index;
            if (firstIndex <= endindex) {
              this.selectItemArr = this.tableData.slice(firstIndex, endindex + 1);
            } else {
              this.selectItemArr = this.tableData.slice(endindex, firstIndex + 1);
            }
          }
        }
      },
      //当企业云盘为以下情况时不显示
      showTeamMenu() {
        var flag = true;
        if (this.$route.query.cloudType == 'gmail' && this.$route.query.folderId == 'root') {
          flag = false;
        }
        if (this.$route.query.cloudType == 'outlook' && this.$route.query.folderId == '/') {
          flag = false;
        }
        return flag;
      },
      //初始化界面数据
      JudgeReacquireData() {
        let that = this;
        this.recycleBinShow = false;
        this.searchResultShow = false;
        let key = this.$route.query.folderId + this.$route.query.tokenId;
        let tableData = this.$store.state.cacheTableDatas[key];
        //获取路径
        this.getPathJson();
        //判断是否显示粘贴选项
        this.judePasteShow();
        //如果缓存中有数据
        if (tableData && tableData.id == (this.$route.query.folderId + this.$route.query.tokenId)) {
          this.loading = false;
          this.docType = tableData.docType;
          if (tableData.tableData) {
            let tableDataNewArr = [];
            //如果第一个文件为新建文件，防止新建样式被覆盖
            if (this.tableData[0] && this.tableData[0].newFolder) {
              tableDataNewArr = tableData.tableData;
              tableDataNewArr.unshift(this.tableData[0]);
            } else {
              tableDataNewArr = tableData.tableData;
            }
            tableDataNewArr.forEach(item => {
              //修改系统文件夹名，多语言
              if(item.oldName){
                item.name = that.$t('language.emailExploer.folderName.'+item.oldName);
              }
            });
            this.tableData = tableDataNewArr;
            this.nextPage = tableData.nextPage;
            if (this.tableData[0] && !this.tableData[0].pnode) { //若数据没有pnode，则进行封装
              for (let i = 0; i < this.tableData.length; i++) {
                that.packagePnode(this.tableData[i], that.pathJson.length - 1);
              }
            }
          }
          //对数据进行排序
          this.$nextTick(function() {
            //判断是否有其他界面过来的选中数据
            commonUtils.ifHasDataSelect(this);
          });
        } else {
          //如果缓存中没有数据，则访问后端
          if (this.openFileFlag) {
            this.tableData = [];
            //初始化数据
            this.initialFileData();
          }
        }
      },
      //打开离线任务弹窗
      linkTaskOpen() {
        if (this.$route.query.cloudType == 'googlePhotos' && (this.$route.query.folderId == '/albums' || this.$route
            .query.folderId == '/photos')) {
          if (this.$route.query.folderId == '/albums') {
            this.$toast({
              text: this.$t('language.exception.notMediaFiles'),
              type: 'notice',
              idValue: 'rightBo',
              learnMoreShow: false
            });
          }
          if (this.$route.query.folderId == '/photos') {
            this.$toast({
              text: this.$t('language.exception.onlyStoreImages'),
              type: 'notice',
              idValue: 'rightBo',
              learnMoreShow: false
            });
          }
        }
        this.rightBlankMenuShow = false;
        this.rightMenuShow = false;
        this.uploadFileItemShow = false;
        let node = {};
        node.driveType = this.$route.query.cloudType;
        node.driveId = this.$route.query.tokenId;
        node.name = this.$route.query.folderName;
        node.id = this.$route.query.folderId;
        let path = this.pathJson[0].name;
        for (let i = 1; i < this.pathJson.length; i++) {
          path = path + '\\' + this.pathJson[i].name;
        }
        for (let j = this.pathJson.length - 1; j >= 0; j--) {
          if (this.pathJson[j].id != node.id) {
            let pnode = {
              driveType: this.$route.query.cloudType,
              driveId: this.$route.query.tokenId,
              name: this.pathJson[j].name,
              id: this.pathJson[j].id,
            }
            this.setPnode(node, pnode);
          }
        }
        node.pid = this.pathJson[this.pathJson.length - 1].id;
        // 如果当前已经存在解析任务，则停止继续。
        let parseMagnet = this.$store.state.parseMagnet;
        if (parseMagnet == "Running") {
          this.$toast({
            text: this.$t('language.popup.remoteTaskPopup.parseTaskRunning'),
            type: 'fail',
            idValue: "rightBo"
          });
          return;
        }
        if (!this.$refs.parseTipsDialog.parseTipsShow) {
          this.$refs.linkTaskDialog.toDrivesInfo = node;
          this.$refs.linkTaskDialog.cloudType = node.driveType;
          this.$refs.linkTaskDialog.cloudCatalog = path;
          this.$refs.linkTaskDialog.linkTaskShow = true;
        }
      },
      //设置父节点
      setPnode(node, pnode) {
        if (!node.pnode) {
          node.pnode = pnode;
        } else {
          this.setPnode(node.pnode, pnode);
        }
      },
      //初始化搜索数据
      initSearchData() {
        if (this.$route.query.searchResult) {
          this.loading = false;
          this.searchResultShow = true;
          let that = this;
          this.$nextTick(function() {
            that.selectItemArr = [];
            if (that.$store.state.cacheTableDatas[1111 + 'search']) {
              that.tableData = that.$store.state.cacheTableDatas[1111 + 'search'].tableData;
            } else {
              that.tableData = [];
            }
            if (!this.objOfPropertyToArr(that.$store.state.cacheTableDatas).length) {
              this.toHomePage();
            }
          });
        }
      },
      // 将Object的属性输出成Array
      objOfPropertyToArr(object) {
        var arr = [];
        var i = 0;
        for (var item in object) {
          arr[i] = item;
          i++;
        }
        return arr;
      },
      //如果是回收站，初始化回收站数据
      initTrashData() {
        if (this.$route.query.folderId == 'recycle_bin') {
          this.getPathJson();
          let id = 'recycle_bin' + this.$route.query.tokenId;
          if (this.$store.state.cacheTableDatas[id] && this.$store.state.cacheTableDatas[id].id == (this.$route.query
              .folderId + this.$route.query.tokenId)) {
            this.tableData = this.$store.state.cacheTableDatas[id].tableData;
            this.docType = this.$store.state.cacheTableDatas[id].docType;
            this.nextPage = this.$store.state.cacheTableDatas[id].nextPage;
          }
          this.recycleBinShow = true;
          this.selectItemArr = [];
          if (!this.tableData.length) {
            //如果缓存没有对应的数据，就进行回收站请求
            this.trashRequest();
          }
        }
      },
      //通过搜索的结果，跳转到对应的一个结果界面
      jumpTo() {
        let that = this;
        let id;
        let fileName;
        let selectItem = this.selectItemArr[0];
        if (selectItem.parentNodes.length) {
          id = selectItem.parentNodes[selectItem.parentNodes.length - 1].id;
          fileName = selectItem.parentNodes[selectItem.parentNodes.length - 1].name;
        } else {
          id = selectItem.rootId;
          fileName = selectItem.rootName;
        }
        // let listData = new cloudExploerUtils.emaillistData(id, commonUtils.getUser().id, selectItem.driveId, null, 0,null,null);
        that.$store.commit("setCatalogFileId", selectItem.id);
        that.searchResultShow = false;
        that.searchMenuShow = false;
        that.$router.push({
          name: "emailExploer",
          query: {
            cloudType: selectItem.driveType,
            folderId: id,
            folderName: fileName,
            tokenId: selectItem.driveId,
            docType: selectItem.docType,
            queryParameter: selectItem.queryParameter
          }
        });
        that.pathJson = [];
        that.$forceUpdate();
        that.commitSearchResultData(selectItem);
        let sourId = that.$store.state.catalogFileId;
        that.selectLeftOption(selectItem);
        that.$store.commit("setCatalogFileId", sourId);
      },
      //选中左侧的菜单栏
      selectLeftOption(selectItem) {
        let dom;
        let rootDirName;
        let that = this;
        $.each(that.$parent.$children, function(i, item) {
          if (item.menuOptions) {
            dom = that.$parent.$children[i];
            return;
          }
        });
        let clouds = dom.clouds;
        if (selectItem.parentNodes.length) {
          rootDirName = selectItem.parentNodes[0].name;
        } else {
          rootDirName = selectItem.rootName;
        }
        $.each(clouds, function(i, item) {
          if (rootDirName == item.name && selectItem.driveId == item.id) {
            dom.driveOptionSelect(i);
          }
        });
      },
      //还原回收站文件
      RestoreFile() {
        let that = this;
        let selectData = Object.assign([], this.selectItemArr);
        for (let i = 0; i < selectData.length; i++) {
          let restoreData = new cloudExploerUtils.restoreData(commonUtils.getUser().id, this.$route.query.tokenId,
            'recycle_bin', selectData[i].id, selectData[i].dir);
          this.Utils.doFilesRequest('restore', restoreData).then(res => {
            if (res.status == 200) {
              that.selectItemArr = [];
              that.tableData.some((item, j) => {
                if (item.id == selectData[i].id) {
                  that.tableData.splice(j, 1);
                  that.recycleMenuShow = false;
                  that.recycleBinShowf = false;
                  return true;
                }
              });
            } else {
              this.$toast({
                text: this.$t('language.cloudExploer.failedRestore'),
                type: 'fail',
                idValue: "rightBo"
              });
            }
          });
        }
      },
      //提交搜索的结果
      commitSearchResultData(selectItem) {
        let that = this;
        if (selectItem.parentNodes.length) {
          for (let i = 0; i < selectItem.parentNodes.length; i++) {
            let folderId = selectItem.parentNodes[i].id;
            that.pathJson.push({
              id: selectItem.parentNodes[i].id,
              name: selectItem.parentNodes[i].name,
              driveId: selectItem.driveId
            });
            let JsonList = Object.assign([], that.pathJson);
            that.$store.commit("setPathJson", {
              folderId: folderId + selectItem.driveId,
              json: JsonList
            });
          }
        } else {
          that.pathJson.push({
            id: folderId,
            name: this.$route.query.folderName,
            driveId: selectItem.driveId
          });
          let JsonList = Object.assign([], that.pathJson);
          that.$store.commit("setPathJson", {
            folderId: folderId + selectItem.driveId,
            json: JsonList
          });
        }
      },
      //提交路径数据
      commitPathData() {
        let pathData;
        let folderId = this.$route.query.folderId;
        let pathJson;
        pathJson = this.$store.state.pathJson;
        pathData = pathJson[folderId + this.$route.query.tokenId];
        if (!pathData) {
          pathJson = this.$store.getters.getPathJson;
          if (pathJson) {
            pathData = pathJson[folderId + this.$route.query.tokenId];
          }
        }
        if (!pathData || (pathData && this.$route.query.tokenId && pathData.json[0].driveId != this.$route.query
            .tokenId)) {
          if (this.pathJson.length > 0 && this.pathJson[0].id != this.$route.query.folderId) {
            this.pathJson.push({
              id: folderId,
              name: this.$route.query.folderName,
              driveId: this.$route.query.tokenId,
              docType: this.$route.query.docType,
              queryParameter: this.$route.query.queryParameter
            });
            let JsonList = Object.assign([], this.pathJson);
            this.$store.commit("setPathJson", {
              folderId: folderId + this.$route.query.tokenId,
              json: JsonList
            });
          }
        }
      },
      //临时任务窗口打开和关闭
      snapTasksOpen() {
        this.$store.state.snapTaskShow = !this.$store.state.snapTaskShow;
      },
      onDrag(e) {
        e.stopPropagation();
        e.preventDefault();
      },
      //上传文件
      onDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        //判断是否是临时用户，然后提醒用户进行绑定邮箱
        let user = commonUtils.getUser();
        if (commonUtils.testUserIsTourist(user)) {
          this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
          this.$refs.remindBindEmailDialog.fromSign = 3;
          return false;
        }
        let totalSize = 0;
        let that = this;
        this.currentIndex = -1;
        var dt = e.dataTransfer;
        this.filesArr = [];
        $.each(dt.files, function(i, item) {
          that.filesArr.push(item);
        });
        if (dt.files.length) {
          if (this.$route.query.cloudType == 'googlePhotos' && this.$route.query.folderId == '/') {
            this.$toast({
              text: 'Upload is disabled.',
              type: 'fail',
              idValue: "rightBo"
            });
            return false;
          }
          $.each(this.filesArr, function(i, item) {
            totalSize = totalSize + item.size;
          });
          if (totalSize > 1024 * 1024 * 1024) {
            this.$toast({
              text: this.$t('language.cloudExploer.uploadSize'),
              type: 'fail',
              idValue: "rightBo"
            });
            that.filesArr.splice(i, 1);
            return false;
          }
          if ((this.$refs.snapTaskDialog.items.length + this.filesArr.length) > 200) {
            let index = (this.$refs.snapTaskDialog.items.length + this.filesArr.length) - 200;
            this.filesArr.splice(this.filesArr.length - index, this.filesArr.length + 1);
            this.$toast({
              text: this.$t('language.cloudExploer.simultaneous'),
              type: 'fail',
              idValue: "rightBo"
            });
          }
          for (let i = 0; i < this.filesArr.length; i++) {
            let uploadFileData = that.filesArr[i];
            //判断文件是否重命名
            var name = that.judgeRepeatUploadFileName(uploadFileData.name);
            let uploadData = {
              ud: commonUtils.getUser().id,
              dd: that.$route.query.tokenId,
              tid: that.$route.query.folderId,
              n: name,
              upId: commonUtils.randomRangeId(10), //前端随机生成用于匹配的10位数ID
            }
            that.$store.state.uploadArr.push({
              name: name,
              percent: 0,
              status: 'ready',
              uploadData: uploadData,
              cloudType: that.$route.query.cloudType,
              uploadFileData: uploadFileData
            });
          }
          that.snapTaskIconShow = true;
          that.$store.state.snapTaskShow = true;
          that.$refs.snapTaskDialog.transferFlag = false;
          //触发上传的事件
          commonUtils.uploadFileChange();
        }
      },
      //初始化文件数据
      initialFileData() {
        this.loading = true;
        this.noMore = false;
        if (!this.$route.query.tokenId) {
          return;
        }
        let listData = new cloudExploerUtils.emaillistData(this.$route.query.folderId, commonUtils.getUser().id, this
          .$route.query.tokenId, this.$route.query.docType, this.limit,null, this.$route.query.queryParameter);
        this.openFileFlag = false;
        this.getPathJson();
        let that = this;
        that.listFileData(listData, function(message) {
          that.openFileFlag = true;
          if (message == "Success") {
            that.loading = false;
            if (that.$route.query.tokenId == listData.dd && listData.id == that.$route.query.folderId && (!
                commonUtils.pathExcludeBackupRoot(that.pathJson))) {
              that.$store.commit("setCacheTableDatas", {
                id: listData.id + that.$route.query.tokenId,
                docType: that.docType,
                tableData: that.tableData,
                nextPage: that.nextPage
              });
            }
            that.selectItemArr = [];
          } else {
            that.loading = false;
          }
        });
      },
      //获取下一页信息
      nextFileData() {
        if (!this.$route.query.tokenId) {
          return;
        }
        this.nextLoading = true;
        this.noMore = false;
        let listData = new cloudExploerUtils.emaillistData(this.$route.query.folderId, commonUtils.getUser().id, this
          .$route.query.tokenId, this.$route.query.docType, this.limit,this.nextPage, this.$route.query.queryParameter);
        this.openFileFlag = false;
        let that = this;

        that.Utils.doCloudEmailRequest("list", listData, {
          timeout: 600000
        }).then(res => {
          
          if (res.status == 200) {
            if (res.items.length) { //如果返回了数据
              for (let i = 0; i < res.items.length; i++) { //给每条数据符上云盘类型，Pid,云盘类型id
                res.items[i].driveType = that.$route.query.cloudType;
                res.items[i].pid = listData.id;
                res.items[i].driveId = listData.dd;
                res.items[i].cloudType = res.cloudType;
                if(!res.items[i].subject){
                  if(!res.items[i].name){
                    //没有name也没有subject，默认显示无主题
                    res.items[i].name = "No Subject";
                  }
                  //没有subject，默认显示无主题
                  res.items[i].subject = that.$t('language.emailExploer.noSubject');
                }
                if(!res.items[i].name){
                  //没有name，默认subject为name
                  res.items[i].name = res.items[i].subject;
                }
                if (that.$store.getters.getlistData && that.$store.getters.getlistData.cloud) {
                  res.items[i].cloud = Object.assign({}, that.$store.getters.getlistData.cloud);
                }
              }
            }
            //如果此时用户未切换界面，把数据存入缓存
            if (that.$route.query.tokenId == listData.dd && listData.id == that.$route.query.folderId) {
              if(res.nextPage){
                that.nextPage = res.nextPage;
              }else{
                //最后一页
                that.nextPage = null;
              }
              let newTableData = Object.assign([], res.items);
              that.tableData = that.tableData.concat(newTableData);
              if(that.tableData.length<=1000&&(that.$route.query.docType=='category')){
                that.tableData = commonUtils.sortArr(that.tableData, this.upShow, 4);
              }
              if(that.$route.query.cloudType=='outlook'){
                that.tableData = commonUtils.sortArrEmail(that.tableData, true, 0);
              }
              that.$store.commit("setCacheTableDatas", {
                id: listData.id + listData.dd,
                docType: that.docType,
                tableData: that.tableData,
                nextPage: that.nextPage
              });
              that.$refs.elscrollbar.update();
            }
          } else {
            //如果后端报未找到，则抛出错误
            if ((res.msg && res.msg.search('not_found') != -1) || res.status == 404 || (res.msg && res.msg.search(
                'Item does not exist') != -1)) {
              this.$toast({
                text: that.$t('language.exception.pathNotFound'),
                type: 'fail',
                idValue: "rightBo"
              });
            } else if (res.reason == 'delete error') {
              this.$toast({
                text: that.$t('language.exception.reachedLimit'),
                type: 'fail',
                idValue: "rightBo"
              });
            } else if (res.reason == 'tooManyRequests429') {
              that.$toast({
                text: that.$t('language.exception.tooManyRequests429',{"date":commonUtils.transferTime(res.msg-0)}),
                type: 'fail',
                idValue: "rightBo"
              });
            } else {
              that.$toast({
                text: that.$t('language.exception.' + res.reason),
                type: 'fail',
                idValue: "rightBo"
              });
            }
          }
          that.$nextTick(function() {
            this.nextLoading = false;
          });
        }, err => {
          that.isflage = true;
          that.checkFlag = true;
          that.nextLoading = false;
        });
      },
      //没有加载数据的加载效果
      noLoadInitialFileData(callback) {
        let listData = new cloudExploerUtils.emaillistData(this.$route.query.folderId, commonUtils.getUser().id, this
          .$route.query.tokenId, this.$route.query.docType, this.limit,this.nextPage, this.$route.query.queryParameter);
        this.getPathJson();
        let that = this;
        that.listFileData(listData, function(message) {
          if (message == "Success") {
            callback('Success');
          }
        });
      },
      //关闭窗口搜索
      handleClose() {
        this.$refs.searchDialog.searchDialogShow = false;
      },
      //显示粘贴菜单
      judePasteShow() {
        if ((this.$store.state.cutArr && this.$store.state.cutClonArr.length) || (this.$store.state.copyArr && this
            .$store.state.copyArr.length)) {
          this.pasteFlag = true;
        }
        //若在当前目录则不能剪切后粘贴
        if (this.$route.query.folderId == this.$store.state.cutFolderId && this.$store.state.cutClonArr.length) {
          this.pasteFlag = false;
        }
      },
      //匹配文件类型
      matchfileType(fileName) {
        return commonUtils.matchfileTypes(fileName);
      },
      //得到路径
      getPathJson() {
        if (!this.$route.query.tokenId) {
          return;
        }
        let Base64 = require('js-base64').Base64;
        var pathJson = [];
        if (localStorage.getItem("path")) {
          let pathArr = JSON.parse(Base64.decode(localStorage.getItem("path")));
          let pathData = pathArr[this.$route.query.folderId + this.$route.query.tokenId];
          if (!pathData) {
            pathJson = this.$store.getters.getPathJson;
            if (pathJson) {
              pathData = pathJson[this.$route.query.folderId + this.$route.query.tokenId];
              if (pathData && pathData.json.length) {
                pathJson = pathData.json;
                if (pathData.json[pathData.json.length - 1].name != this.$route.query.folderName && this.$route.query
                  .folderName != 'recycle_bin') {
                  pathData.json[pathData.json.length - 1].name = this.$route.query.folderName;
                }
                //如果是正常的云盘界面
                this.pathJson = this.pathJsonFilter(Object.assign([], pathJson));
              } else {
                this.packageNullPath([]);
              }
            }
          }
          if (pathData) {
            pathJson = pathData.json; //如果路径名称和之前缓存的不相等，则显示名称为新的
            if (pathJson[pathJson.length - 1].name != this.$route.query.folderName && this.$route.query.folderName !=
              'recycle_bin') {
              if (this.$route.query.folderName) {
                pathJson[pathJson.length - 1].name = this.$route.query.folderName;
              }
            }
            let pLength = pathJson.length;
            if (this.$store.state.openFileFlag) {
              //如果是打开文件夹操作，1.如果打开目录的长度不等于现在pnode长度+1，并且最末端的id不相等，则更改路径名 2.如果打开目录的长度等于现在pnode长度+1,新打开的路径上一个目录的id不等于现在路径最末节点的id
              if (((this.pathJson.length + 1 != pathJson.length) && pathJson[pathJson.length - 1].id != this.pathJson[
                  this.pathJson.length - 1].id) || (this.pathJson.length + 1 == pLength && pLength >= 2 && pathJson[
                  pathJson.length - 2].id != this.pathJson[this.pathJson.length - 1].id)) {
                this.packageNullPath(pathJson);
              }
            }
            this.$store.state.openFileFlag = false;
            this.pathJson = this.pathJsonFilter(Object.assign([], pathJson));
          }
        }
      },
      //如果云盘管理界面的路径过长，则省略号表示
      pathJsonFilter(newValue) {
        let subArray = new Array();
        let subArrayOne = new Array();
        let subArrayTwo = new Array();
        let clonArr = newValue;
        let navigation = this.$refs.navigation;
        var nameStr = '';
        for (var i = 0; i < newValue.length; i++) {
          var str = newValue[i].name;
          if (str.length > 13) {
            str = str.slice(0, 6) + '..' + str.slice(str.length - 6, str.length);
          }
          nameStr = nameStr + str;
        }
        let navigationWidth = nameStr.length * 15;
        if (clonArr.length >= 13 || (navigation && navigation.clientWidth && (navigation.clientWidth <
            navigationWidth))) {
          subArrayOne = clonArr.slice(0, 3); //截取前三个
          subArrayTwo = clonArr.slice(clonArr.length - 2); //从第四个字符截取到末尾
          $.each(subArrayOne, function(i, item) {
            subArray.push(item);
          });
          let sbuData = {
            id: 'addEllipsis',
            name: '... ...'
          }
          subArray.push(sbuData);
          $.each(subArrayTwo, function(j, data) {
            subArray.push(data);
          });
        } else {
          subArray = clonArr;
        }
        return subArray;
      },
      //回到上一级别目录
      comeBackFile(event, path, index) {
        this.$store.state.openFileFlag = false;
        if (path.id != this.$route.folderId) {
          this.selectItemArr = [];
          let dom = event.currentTarget;
          this.recycleBinShow = false;
          this.closeAllMenu();
          this.$router.push({
            name: "emailExploer",
            query: {
              cloudType: this.$route.query.cloudType,
              folderId: path.id,
              folderName: path.name,
              tokenId: this.$route.query.tokenId,
              docType: path.docType,
              queryParameter: path.queryParameter
            }
          });
        }
      },
      //跳转到云盘官网
      goOfficialSite() {
        let goData = new cloudExploerUtils.goOfficialSiteData(commonUtils.getUser().id, this.$route.query.tokenId, this
          .selectItemArr[0].pid, this.selectItemArr[0].id);
        this.Utils.doFilesRequest("go_drive_site", goData).then(res => {
          if (res.status == 200) {
            window.open(res.webSite);
            this.rightMenuShow = false;
            this.moreChooseShow = false;
            this.shareChooseShow = false;
          }
        });
      },
      packagePnode(item, j) {
        let that = this;
        if (j >= 0) { //给每条数据赋值父节点数据
          item.pnode = that.pathJson[j];
          that.packagePnode(item.pnode, j - 1);
        }
      }, //如果没有路径则进行封装
      packageNullPath(pathJson) {
        pathJson = this.pathJson; //打开文件夹的新路径信息等于当前目录的路径+导航栏路径
        let newData = { //封装打开的新路径
          driveId: this.$route.query.tokenId,
          id: this.$route.query.folderId,
          name: this.$route.query.folderName,
          docType: this.$route.query.docType,
          queryParameter: this.$route.query.queryParameter,
        }
        pathJson.push(newData);
        let JsonList = Object.assign([], pathJson);
        this.$store.commit("setPathJson", {
          folderId: newData.id + newData.driveId,
          json: JsonList
        });

      },
      //列出列表
      listFileData(listData, callback) {
        let message = "";
        let that = this;
        this.isflage = false; //向后端进行请求时禁用一些点击事件
        that.commitPathData(); //提交路径数据
        that.Utils.doCloudEmailRequest("list", listData, {
          timeout: 600000
        }).then(res => {
          that.getPathJson(); //获取路径数据
          that.isflage = true; //数据加载成功后取消禁用
          that.checkFlag = true;
          if (res.status == 200) {
            //如果该文件夹包含类型，则需要进行记录
            if(that.$route.query.driveType){
              that.docType = that.$route.query.driveType;
            }
            if (res.items.length) { //如果返回了数据
              for (let i = 0; i < res.items.length; i++) { //给每条数据符上云盘类型，Pid,云盘类型id
                res.items[i].driveType = that.$route.query.cloudType;
                res.items[i].pid = listData.id;
                res.items[i].driveId = listData.dd;
                res.items[i].cloudType = res.cloudType;
                if(res.items[i].docType=='category'){
                  //系统文件夹需要多语言
                  if(res.items[i].initial){
                    //保存原始名称
                    res.items[i].oldName = res.items[i].name;
                    if(res.items[i].name != "All Mail"){
                      res.items[i].name = that.$t('language.emailExploer.folderName.'+res.items[i].name);
                    }else{
                      res.items[i].oldName = "AllMail";
                      res.items[i].name = that.$t('language.emailExploer.folderName.AllMail');
                    }
                  }
                }else{
                  if(!res.items[i].subject){
                    if(!res.items[i].name){
                      //没有name也没有subject，默认显示无主题
                      res.items[i].name = "No Subject";
                    }
                    //没有subject，默认显示无主题
                    res.items[i].subject = that.$t('language.emailExploer.noSubject');
                  }
                  if(!res.items[i].name){
                    //没有name，默认subject为name
                    res.items[i].name = res.items[i].subject;
                  }
                }
                // if(res.items[i].docType=="thread"){
                //   //没有queryParameter，默认threadId为queryParameter
                //   res.items[i].id = res.items[i].id;
                // }
                if (that.$store.getters.getlistData && that.$store.getters.getlistData.cloud) {
                  res.items[i].cloud = Object.assign({}, that.$store.getters.getlistData.cloud);
                }
                let item = res.items[i];
                that.packagePnode(item, that.pathJson.length - 1); //前端手动给节点赋值
              }
            }
            //如果此时用户未切换界面，把数据存入缓存
            if (that.$route.query.tokenId == listData.dd && listData.id == that.$route.query.folderId) {
              //是否有下一页
              if(res.nextPage){
                that.nextPage = res.nextPage;
              }else{
                //最后一页
                that.nextPage = null;
              }
              
              that.tableData = Object.assign([], res.items);
              //如果是会话页面
              if(that.$route.query.docType=="thread"&&that.tableData.length>0){
                //第一封邮件默认展开
                that.tableData[that.tableData.length-1].isLast = true;
              }
              if(that.$route.query.docType=='category'){
                that.tableData = commonUtils.sortArr(that.tableData, this.upShow, 4);
              }
              if(that.$route.query.cloudType=='outlook'){
                that.tableData = commonUtils.sortArrEmail(that.tableData, true, 0);
              }
              that.$store.commit("setCacheTableDatas", {
                id: listData.id + listData.dd,
                docType: that.docType,
                tableData: that.tableData,
                nextPage: that.nextPage
              });
              //判断数据是否有选中
              that.$nextTick(function() {
                commonUtils.ifHasDataSelect(that);
              });
            }
          } else {
            //如果后端报未找到，则抛出错误
            if ((res.msg && res.msg.search('not_found') != -1) || res.status == 404 || (res.msg && res.msg.search(
                'Item does not exist') != -1)) {
              this.$toast({
                text: that.$t('language.exception.pathNotFound'),
                type: 'fail',
                idValue: "rightBo"
              });
            } else if (res.reason == 'delete error') {
              this.$toast({
                text: that.$t('language.exception.reachedLimit'),
                type: 'fail',
                idValue: "rightBo"
              });
            } else if (res.reason == 'tooManyRequests429') {
              that.$toast({
                text: that.$t('language.exception.tooManyRequests429',{"date":commonUtils.transferTime(res.msg-0)}),
                type: 'fail',
                idValue: "rightBo"
              });
            } else if (res.reason=="unknownError" && res.msg.indexOf("real:")==0) {
              that.$toast({
                text: res.msg.substring(5),
                type: 'fail',
                idValue: "rightBo"
              });
            } else {
              that.$toast({
                text: that.$t('language.exception.' + res.reason),
                type: 'fail',
                idValue: "rightBo"
              });
            }
          }
          message = res.message;
          callback(message);
        }, err => {
          that.isflage = true;
          that.checkFlag = true;
        });
      },
      //准备预览文件或打开文件夹
      readyOpenFile(item) {
        if (this.checkFlag) { //只有checkFlag为真才能点击打开
          if (!item.inputValue && item.inputValue != "") {
            if (this.$route.query.folderId != 'recycle_bin' && !this.searchResultShow) {
              this.$store.commit("setCatalogFileId", '');
              //如果是文件则调用预览接口
              if (!item.dir) {
                let previewData = new cloudExploerUtils.previewData(commonUtils.getUser().id, this.$route.query.tokenId,
                  item.id, item.name);

                this.Utils.doFilesRequest("download.createSession", previewData).then(result => {
                  item.url = commonUtils.createPreviewLinkForm(result.download_id);
                  let previewItem = Object.assign({}, item);
                  delete previewItem.cloud;
                  previewItem.cloud = {};
                  if (item.cloud && item.cloud.methods) {
                    previewItem.cloud.methods = item.cloud.methods;
                  }
                  this.$store.commit('setPreviewData', [previewItem]);
                  this.$router.push({
                    name: "preview"
                  });
                });
                this.$store.state.datafirstIndex = this.datafirstIndex;
                this.$store.state.endIndex = this.endIndex;
              } else {
                //此处打开文件夹
                this.openFileFlag = true;
                this.$store.state.openFileFlag = true;
                this.$store.commit('setCloudExploerPasteItems', item);
                this.$router.push({
                  name: "emailExploer",
                  query: {
                    cloudType: this.$route.query.cloudType,
                    folderId: item.id,
                    folderName: item.name,
                    tokenId: this.$route.query.tokenId,
                    docType: item.docType,
                    queryParameter: item.queryParameter
                  }
                });

              }
            } else {
              //如果想打开回收站里面的文件则系统提示报错
              if (this.$route.query.folderId == 'recycle_bin') {
                this.$toast({
                  text: this.$t('language.cloudExploer.needRestore'),
                  type: 'fail',
                  idValue: "rightBo"
                });
              }
            }
          }
        }
      },
      //点击刷新界面按钮
      reFresh() {
        this.$refs.deleteDialog.flag = true;
        this.tableData = [];
        this.selectItemArr = [];
        if (this.$route.query.folderId == 'recycle_bin') {
          this.trashRequest();
        } else {
          this.initialFileData();
          this.judePasteShow();
        }
      },
      //显示搜索弹窗
      searchPopupShow() {
        this.closeAllMenu();
        let show = this.$refs.searchDialog.searchDialogShow;
        this.$refs.searchDialog.searchDialogShow = !show;
      },
      //显示离线任务
      dropDownValueShow() {
        this.uploadFileItemShow = !this.uploadFileItemShow;
        if (this.uploadFileItemShow == true) {
          this.dropDownName = "drop-down-up";
        } else {
          this.dropDownName = "dropdown-purple";
        }
      },
      //判断是否都是文件夹
      judgeEqual() {
        let arr = this.selectItemArr;
        for (var i = 0; i <= arr.length - 1; i++) {
          if (arr[i].dir != arr[0].dir) {
            return false;
            break;
          }
        }
      },
      //判断是否选中的都是文件
      judgeShow() {
        this.selectIsFile = false;
        let judgeValue = this.judgeEqual();
        if (judgeValue == undefined && this.selectItemArr[0] && this.selectItemArr[0].dir == false) {
          this.selectIsFile = true;
        }
      },
      //选中一条数据
      clickBoxAddTableCheck(item, index) {
        if (this.checkFlag) {
          this.addTableCheck(item, index);
          this.rightMenuShow = false;
          this.rightBlankMenuShow = false;
          this.moreChooseShow = false;
          this.shareChooseShow = false;
        }
      },
      //选中所有数据
      clickBoxAddAllTableToggle() {
        this.addAllTableToggle();
        this.rightMenuShow = false;
        this.rightBlankMenuShow = false;
        this.moreChooseShow = false;
        this.shareChooseShow = false;
      },
      //选中一条数据
      addTableCheck(item, index) {
        if (this.checkFlag) {
          //如果选中的数据中已经包含了该条数据，再次点击时就会取消选中
          if (this.selectItemArr.includes(item)) {
            this.selectItemArr = this.selectItemArr.filter(
              function(ele) {
                return ele != item;
              });
            //如果数据过滤后为没有选中数据，shift的指针设为初始值
            if (!this.selectItemArr.length) {
              this.firstIndex = -1;
            }
          } else {
            //如果之前没有选中数据，选中数据后，shift的指针设为index
            if (!this.selectItemArr.length) {
              this.firstIndex = index;
              this.startPage = parseInt(this.datafirstIndex / 200);
            }
            this.selectItemArr.push(item);
          }
          this.$store.state.exploerselectedArr = this.selectItemArr; //存储选中数据，用于copy to 时判断是否存在不支持的目标目录
        }
      },
      //选中所有数据
      addAllTableToggle() {
        //再次点击选中所有数据，则清空
        if (this.selectItemArr.length == this.tableData.length && this.tableData.length != 0) {
          this.selectItemArr = [];
        } else {
          //让选中的数据为所有数据
          this.selectItemArr = this.tableData;
        }
        this.$store.state.exploerselectedArr = this.selectItemArr; //存储选中数据，用于copy to 时判断是否存在不支持的目标目录
      },
      //关闭弹窗
      handleSelectClose() {
        this.uploadFileItemShow = false;
        this.dropDownName = "dropdown-purple";
      },
      //关闭更多选项
      moreChooseClose() {
        this.moreChooseShow = false;
      },
      //关闭右键菜单
      rightMenuClose() {
        this.rightMenuShow = false;
      },
      //关闭点击右键空白菜单
      rightBlankMenuClose() {
        this.rightBlankMenuShow = false;
      },
      //关闭搜索界面右键菜单
      searchMenuClose() {
        this.searchMenuShow = false;
      },
      recycleMenuClose() {
        this.recycleMenuShow = false;
      },
      //右键显示菜单事件
      clickRightMenuShow(event, item, index) {
        let that = this;
        event.stopPropagation();
        event.preventDefault();
        this.rightBlankMenuShow = false;
        this.moreChooseShow = false;
        this.shareChooseShow = false;
        event.cancelBubble = true;
        this.selectIsFile = false;
        this.rightMenuShow = false;
        this.searchMenuShow = false;
        this.recycleMenuShow = false; //将云盘管理界面全部的右键菜单显示设置为false
        let element = event.currentTarget;
        if (this.searchResultShow) { //如果是搜索结果界面
          this.searchMenuShow = true;
          this.$nextTick(function() {
            commonUtils.multipleMenuShow("searchMenu", event);
          });
        } else if (this.recycleBinShow) { //如果是回收站结果界面
          this.recycleMenuShow = true;
          this.$nextTick(function() {
            commonUtils.multipleMenuShow("recycleMenu", event);
          });
        } else {
          if (this.checkFlag && this.isflage) {
            //如果是云盘管理界面，显示其右键菜单
            if (!this.selectItemArr.length) {
              this.selectItemArr.push(this.tableData[0]);
            }
            this.rightMenuShow = true; //右键菜单显示
            this.$nextTick(function() { //界面渲染完毕后，执行鼠标右键点击显示，右键菜单始终随着鼠标显示方法
              that.judgeDecryptShow(); //判断该文件或文件夹是否加密，然后显示解密还是加密项
              commonUtils.multipleMenuShow("rightMenu", event);
            });
          }
        }
        if (!this.selectItemArr.includes(item) && this.selectItemArr.length != this.tableData.length) { //右键选中某一项
          this.clickCheckSingleItem(item, index, event);
        }
        if (!this.searchResultShow && !this.recycleBinShow) { //判断粘贴菜单项是否显示
          this.judgeShow();
        }
      },
      //用于判断新建文件夹菜单是否显示
      newFolderShow() {
        let that = this;
        let flag = true;
        //如果以下云盘类型包含了这个类型
        if (that.cloudrootArr.includes(that.$route.query.cloudType)) {
          //如果是googlePhotos则不显示该文件夹
          if (that.$route.query.cloudType == 'googlePhotos') {
            flag = false;
            //Albums则显示新建文件夹
            if (that.$route.query.folderName == 'Albums' || that.$route.query.folderName == 'Sharing') {
              flag = true;
            }
          }
          //如果是dropbox4Business的根目录则不显示
          if (that.$route.query.cloudType == 'dropbox4Business' && that.$route.query.folderId == '/') {
            flag = false;
          }
          //如果是sharePointOnline的站点目录和站点子目录不显示
          if (this.$route.query.cloudType == 'sharePointOnline') {
            if (this.$route.query.folderId == 'root0' || this.isSiteChild())
              flag = false;
          }
        }

        return flag;
      },
      //点击并选中单项
      clickCheckSingleItem(item, index, event) {
        if (event.shiftKey != 1) {
          if (this.selectItemArr.length >= 1) {
            if (this.selectItemArr.length == this.tableData.length) {
              if (this.selectItemArr.includes(item)) {
                this.selectItemArr = this.selectItemArr.filter(
                  function(ele) {
                    return ele != item;
                  });
              }
            } else if (this.selectItemArr.length != this.tableData.length) {
              this.selectItemArr = [];
              this.addTableCheck(item, index);
            }
          } else if (this.selectItemArr.length == 0) {
            this.addTableCheck(item, index);
          }
        } else if (event.shiftKey == 1) {
          this.addTableCheck(item, index);
        }
      },
      //阻止默认事件
      preventMenu(event) {
        event.cancelBubble = true;
        event.stopPropagation();
        event.preventDefault();
      },
      //右键点击空白区域事件，打开菜单
      rightBlankMenuOpen(event) {
        event.cancelBubble = true;
        let element = event.currentTarget;
        event.stopPropagation();
        event.preventDefault();
        let routeCloudType = this.$route.query.cloudType;
        let cloudrootArr = ['dropbox4Business', 'googlePhotos', 41];
        //显示云盘管理界面右键空白菜单
        if ((!this.searchResultShow && !this.recycleMenuShow) && !this.selectItemArr.length) {
          if ((!cloudrootArr.includes(routeCloudType)) || (cloudrootArr.includes(routeCloudType) && this.$route.query
              .folderId != '/')) {
            this.judePasteShow();
            this.rightBlankMenuShow = true;
            this.rightMenuShow = false;
            this.$nextTick(function() {
              commonUtils.multipleMenuShow("rightBlankMenu", event);
            });
          }
        }
        //显示回收站右键菜单
        if (this.selectItemArr.length && this.$route.query.folderId && this.$route.query.folderId == 'recycle_bin') {
          this.recycleMenuShow = true;
          this.$nextTick(function() {
            commonUtils.multipleMenuShow("recycleMenu", event);
          });
        }
        //显示云盘管理界面右键菜单
        if (this.selectItemArr.length) {
          this.rightMenuShow = true; //显示以rightMenuShow来控制显示的菜单
          this.$nextTick(function() {
            commonUtils.multipleMenuShow("rightMenu", event); //调用js公共方法，让该右键菜单随着鼠标点击位置显示
          });
        }
        if (this.$route.query.searchResult && this.selectItemArr.length) {
          this.searchMenuShow = true;
          this.$nextTick(function() {
            commonUtils.multipleMenuShow("searchMenu", event); //调用js公共方法，让该右键菜单随着鼠标点击位置显示
          });
        }
      },
      //编辑文件名
      editName() {
        let that = this;
        this.renameItem = this.selectItemArr[0];
        let itemIndex;
        $.each(this.nowTableData, function(i, item) {
          if (that.renameItem == item) {
            item.inputValue = item.name;
            item.oldNameValue = item.name;
            itemIndex = i;
            return false;
          }
        });
        this.$forceUpdate();
        this.$nextTick(function() {
          that.editCloudInputStyle("block", "none", itemIndex, this.renameItem.dir);
        })
        that.rightMenuShow = false;
      },
      //跳转到历史路由
      backSearch() {
        history.go(-1);
      },
      //正则判断新建桶文件夹是否符合wasabi桶的命名规则
      checkBuket(item) {
        //(?!^\d+$)排除全数字
        var reg = /^(?!^\d+$)[0-9a-z]{3,63}$/;
        if (reg.test(item.inputValue)) {
          return true;
        }
        return false;
      },
          //发送新建文件夹请求
    doMkDirRequest(item, index, element, callback) {
      let that = this;
      let nameArr = [];
      if (that.tableData && that.tableData[0]) {
        that.tableData[0].newFolder = false;
      }
      //如果包含特殊字符则提示
      if (commonstate.pattern.test(this.tableData[0].inputValue)) {
        that.$toast({
          text: that.$t('language.cloudExploer.notContainSpecialChar'),
          type: 'fail',
          idValue: "rightBo",
        });
        this.isflage = true;
        return false;
      }
      //去除空格
      let str = this.tableData[0].inputValue.trim().replace(/\s+/ig, " ");
      //文件名和文件夹名不能以“.”开头或结尾
      if (str.charAt(str.length - 1) == '.' || str.charAt(0) == '.') {
        this.isflage = true;
        that.$toast({
          text: that.$t('language.cloudExploer.notWith'),
          type: 'fail',
          idValue: "rightBo",
        });
        return false;
      }
      //判断是否重命名称
      for (let i = 1; i < this.tableData.length; i++) {
        nameArr.push(this.tableData[i].name);
      }
      commonUtils.includesFileName(nameArr, this.tableData[0].inputValue, that);
      this.tableData[0].inputValue = that.reName.trim().replace(/\s+/ig, " ");
      this.tableData[0].name = that.reName.trim().replace(/\s+/ig, " ");
      let mkdirData = new cloudExploerUtils.mkdirData(this.$route.query.folderId, commonUtils.getUser().id, this
        .$route.query.tokenId, this.tableData[0].inputValue);
      let cloudType = that.$route.query.cloudType;
      if (this.tableData[0].docType) {
        mkdirData.ty = this.tableData[0].docType;
      }
      //关闭之前的编辑效果
      if (that.listShow) {
        that.editCloudInputStyle('none', 'block', index, item.dir);
      } else {
        that.editGridInputStyle('none', 'block', index, item.dir);
      }
      that.Utils.doFilesRequest("mkdir", mkdirData).then(res => {
        if (res.status == 200) {
          if (that.$refs.listInputName[0]) {
            that.$refs.listInputName[0].children[1].children[0].id = "";
            that.$refs.listInputName[0].children[1].children[1].id = "";
          }
          let listData = new cloudExploerUtils.emaillistData(this.$route.query.folderId, commonUtils.getUser().id, this
          .$route.query.tokenId, this.$route.query.docType, this.limit,null, this.$route.query.queryParameter);
          //刷新刚新建文件夹解密的数据，并提交缓存再刷新
          commonUtils.refreshTreeDataFromEmail(listData, cloudType, null, that, function (res1) {
            that.JudgeReacquireData();
            that.isflage = true;
            that.checkFlag = true;
          });
          // this.reFresh();
          that.isflage = true;
          //如果此时云盘界面还在当时那个目录
          if (mkdirData.dd == this.$route.query.tokenId && mkdirData.tid == this.$route.query.folderId) {
            that.tableData[0].id = res.item.id;
            that.tableData[0].name = res.item.name;
          }
        } else if (res.status == 401) {
          that.$toast({
            text: that.$t('language.exception.' + res.reason),
            type: 'fail',
            idValue: "rightBo",
          })
        } else if (res.status == 400) {
          that.$toast({
            text: that.$t('language.exception.' + res.reason),
            type: 'fail',
            idValue: "rightBo",
          })
        } else if (res.reason == 'folderNameIsTooLong') { // 文件夹名字长度过长异常
          that.$toast({
            text: that.$t('language.exception.folderNameIsTooLong'),
            type: 'fail',
            idValue: "rightBo"
          });
        } else if (res.reason == 'fileNameIsTooLong') { // 文件名字长度过长异常
          that.$toast({
            text: that.$t('language.exception.fileNameIsTooLong'),
            type: 'fail',
            idValue: "rightBo"
          });
        } else {
          //如果创建文件夹失败则报错，抛出提示消息
          that.$toast({
            text: that.$t('language.exception.createFolderFailed'),
            type: 'fail',
            idValue: "rightBo",
          });
        }
        callback(res.message);
      });
    },
        //提交名称
    submitName(item, index) {
      let element;
      let that = this;
      this.selectable = false;
      if (this.isflage) {
        this.isflage = false;
        this.cancelFlag = true;
        //判断是哪一种平铺方式
        if (this.listShow) {
          element = this.$refs.listInputName[index];
        } else {
          element = this.$refs.gridInputName[index];
        }
        let sureIcon = element.children[1].children[0].id;
        if (sureIcon) { //判断id是否存在，如果存在则调用新建文件夹接口
          this.newFolderItem = item;
          this.newFolderIndex = index;
          //提交的名称不能为空
          if (!this.tableData[0].inputValue) {
            that.$toast({
              text: that.$t('language.cloudExploer.fileNameNotEmpty'),
              type: 'fail',
              idValue: "rightBo",
            });
            that.isflage = true;
            return false;
          }
          if (!item.name) {
            item.name = item.inputValue;
          }
          //调用新建文件夹接口
          this.doMkDirRequest(item, index, element, function (status) {
            if (status != 'success') {
              that.isflage = true;
              that.cancelEditName(item, index);
            }
          });
        } else {
          //调用重命名接口
          // this.doRenameDirRequest(item, index, element, function (status) {
          //   if (status != 200) {
          //     that.isflage = true;
          //     that.cancelEditName(item, index);
          //   } else {
          //     that.commitEditNamePath(item);
          //   }
          // });
        }
      }
    },
      //聚焦事件
      onfocusEvent() {
        this.isflage = true;
      },
          //取消编辑任务名
    cancelEditName(item, index) {
      this.selectable = false;
      // this.checkFlag=true;
      this.checkFlag = false;
      if (this.isflage) {
        let that = this;
        this.isflage = false;
        this.cancelFlag = true;
        let dom = document.getElementById("cancel");
        if (dom) {
          this.tableData[0].name = item.oldNameValue;
          this.$forceUpdate();
          //还原css样式
          if (this.listShow) {
            this.editCloudInputStyle("none", "block", 0, item.dir);
          } else {
            this.editGridInputStyle("none", "block", 0, item.dir);
          }
          that.$refs.listInputName[0].children[1].children[0].id = "";
          that.$refs.listInputName[0].children[1].children[1].id = "";
          this.tableData.splice(0, 1);
          this.selectItemArr = [];
        } else {
          if (!this.tableData[index].name && !this.tableData[index].oldNameValue) {
            this.tableData[index].name = this.tableData[index].inputValue;
          } else {
            this.tableData[index].name = this.tableData[index].oldNameValue;
          }
          //还原css样式
          if (this.listShow) {
            this.editCloudInputStyle("none", "block", index, item.dir);
          } else {
            this.editGridInputStyle("none", "block", index, item.dir);
          }
          this.selectItemArr = [];
        }
        delete item.inputValue;
        let t = setTimeout(() => {
          that.isflage = true;
          that.checkFlag = true;
          clearTimeout(t);
        }, 400);
      }
    },
      //上边菜单显示
      topRightMenuShow() {
        this.moreChooseShow = !this.moreChooseShow;
        if (this.moreChooseShow) {
          this.shareChooseShow = false;
        }
        this.judgeDecryptShow();
        this.judgeShow();
      },
      //分享菜单显示
      topShareMenuShow() {
        this.shareChooseShow = !this.shareChooseShow;
        if (this.shareChooseShow) {
          this.moreChooseShow = false;
        }
      },
      //显示解密菜单
      judgeDecryptShow() {
        let that = this;
        that.suffixArr = [];
        $.each(this.selectItemArr, function(index, suffixItem) {
          let suffix = commonUtils.matchfileTypes(suffixItem.name);
          that.suffixArr.push(suffix);
        });
      },
      //点击预览文件
      openFileDialog() {
        let input_file = document.getElementById("openFile");
        this.currentIndex = -1;
        this.rightBlankMenuShow = false;
        input_file.click();
      },
      //点击打开文件夹
      openFolderDialog() {
        let input_folder = document.getElementById("openFolder");
        input_folder.click();
      },
      //显示删除弹窗
      deleteDialogOpen() {
        this.$refs.deleteDialog.deleteShow = true;
        this.closeAllMenu();
        this.$refs.deleteDialog.deleteList = this.selectItemArr;
        this.$forceUpdate();
      },
      //清空回收站
      emptyTrash() {
        let that = this;
        let emptyData = new cloudExploerUtils.emptyTrashData(commonstate.user.id, this.$route.query.tokenId);
        that.rightBlankMenuShow = false;
        that.Utils.doFilesRequest("empty_trash", emptyData).then(res => {
          if (res.status == 200) {
            if (that.$route.query.folderId == 'recycle_bin') {
              that.tableData = [];
            }
            let id = 'recycle_bin' + that.$route.query.tokenId;
            that.$store.commit("setCacheTableDatas", {
              id: id,
              docType: that.docType,
              tableData: [],
            });
          }
        });
      },
      //显示copyTo弹窗
      copyToDialogShow() {
        let that = this;
        //每次打开将界面置为最初的位置
        this.$refs.copyToDialog.copyToShow = true;
        this.$refs.copyToDialog.isEmails = true;
        this.$nextTick(() => {
          that.$refs.copyToDialog.$refs.elscrollbar.$refs.wrap.scrollTop = 0;
        });
        this.$refs.copyToDialog.initData();
        this.rightMenuShow = false;
      },
      //新建文件夹
      creatFolder(docType) {
        let that = this;
        if (that.isflage) {
          this.checkFlag = false;
          this.rightBlankMenuShow = false;
          //判断是否有重复名字
          let JsonList = this.judgeRepeatFolderName();
          $.each(this.tableData, function(i, item) {
            JsonList.push(item);
          });
          this.tableData = JsonList;
          let that = this;
          this.$nextTick(function() {
            //显示编辑样式
            that.tableData[0].inputValue = that.tableData[0].name;
            that.tableData[0].oldTaskName = that.tableData[0].name;
            that.tableData[0].docType = docType;
            that.$forceUpdate();
            that.$nextTick(function() {
              //显示input样式，并赋值id
                that.editCloudInputStyle("block", "none", 0, true);
                that.$refs.listInputName[0].children[1].children[0].id = "sure";
                that.$refs.listInputName[0].children[1].children[1].id = "cancel";
            });
          });
        }
      },
      //新建相册
      newFolder(){
        this.creatFolder("FOLDER");
      },
      //新建相册
      newAlbum(){
        this.creatFolder("ALBUM");
      },
      editCloudInputStyle(inputDomStye, divDomStyle, index, isDir) {
        let value;
        if (this.$refs.listInputName && this.$refs.listInputName[index]) {
          //获取input的Dom
          let inputDom = this.$refs.listInputName[index];
          //获取div的Dom
          let divDom = this.$refs.listName[index];
          //分别设置input和div样式的显示和隐藏
          inputDom.style.display = inputDomStye;
          divDom.style.display = divDomStyle;
          //如果是显示input
          if (inputDomStye == 'block') {
            this.$forceUpdate();
            this.$nextTick(function() {
              //让input聚焦
              inputDom.children[0].focus();
              //如果是文件，则选中后缀之前的值
              if (!isDir) {
                value = commonUtils.getPrefix(inputDom.children[0].value);
              } else {
                //如果是文件夹则选中所有的值
                value = inputDom.children[0].value;
              }
              //设置选中区域
              inputDom.children[0].setSelectionRange(0, value.length);
              this.$forceUpdate();
            });
          }
        }
      },
      editGridInputStyle(inputDomStye, divDomStyle, index, isDir) {
        let value;
        //获取input的Dom
        let inputDom = this.$refs.gridInputName[index];
        //获取div的Dom
        let divDom = this.$refs.gridName[index];
        //分别设置input和div样式的显示和隐藏
        inputDom.style.display = inputDomStye;
        divDom.style.display = divDomStyle;
        //如果是显示input
        if (inputDomStye == 'block') {
          this.$forceUpdate();
          this.$nextTick(function() {
            //如果是文件，则选中后缀之前的值
            if (!isDir) {
              value = commonUtils.getPrefix(inputDom.children[0].value);
            } else {
              //如果是文件夹则选中所有的值
              value = inputDom.children[0].value;
            }
            //让input聚焦
            inputDom.children[0].focus();
            //设置选中区域
            inputDom.children[0].setSelectionRange(0, value.length);
          });
        }
      },
      //判断是否有重复的文件夹名
      judgeRepeatFolderName() {
        let JsonList = [];
        //初始化新建文件夹名
        var name = "New Folder";
        var j = 0;
        //遍历该列表所有数据
        for (let i = 0; i < this.tableData.length; i++) {
          //如果有一样的名字，则增加括号，让数字加1
          if (this.tableData[i].name == name) {
            j = j + 1;
            name = "New Folder(" + j + ")";
            //让指针初始化为-1；再继续进行遍历
            i = -1;
            continue;
          }
        }
        let newItem = new cloudExploerUtils.newItem(name, true, this.$route.query.tokenId, this.$route.query.folderId);
        //把新建文件夹的名字放在第一个
        newItem.newFolder = true;
        JsonList.push(newItem);
        return JsonList;
      },

      //下载文件
      downLoadFile() {
        let user = commonUtils.getUser();
        if (commonUtils.testUserIsTourist(user)) {
          this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
          this.$refs.remindBindEmailDialog.fromSign = 2;
          return false;
        }
        //多选下载不允许超过200个
        if(this.selectItemArr.length>200){
          this.$toast({
            text: this.$t('language.emailExploer.downloadMax200'),
            type: 'fail',
            idValue: "rightBo"
          });
          return;
        }
        //关闭右侧菜单
        this.rightMenuShow = false;
        //打开下载提示弹窗
        this.$refs.downloadDialog.init(this.selectItemArr);
      },
      //判断上传的文件是否和将上传的目录是否重名
      judgeRepeatUploadFileName(fileName) {
        var newFileName = fileName;
        var j = 0;
        //将该界面的数据名称和准备待上传的数据名称放入名字数组
        let allNameArr = [];
        for (let i = 0; i < this.tableData.length; i++) {
          allNameArr.push(this.tableData[i].name);
        }
        for (let m = 0; m < this.$refs.snapTaskDialog.items.length; m++) {
          //如果上传的文件是同云盘并且是同目录的，才将待上传的文件进行重命名
          if (this.$refs.snapTaskDialog.items[m].uploadData && this.$refs.snapTaskDialog.items[m].uploadData.tid == this
            .$route.query.folderId && this.$refs.snapTaskDialog.items[m].uploadData.dd == this.$route.query.tokenId) {
            allNameArr.push(this.$refs.snapTaskDialog.items[m].name);
          }
        }
        //遍历文件名数组
        for (let n = 0; n < allNameArr.length; n++) {
          //如果该名称和已有名字重复
          if (allNameArr[n] == newFileName) {
            j = j + 1;
            var name = commonUtils.getPrefix(fileName);
            //则在后缀加1
            newFileName = name + '(' + j + ').' + commonUtils.getSuffix(fileName);
            n = -1; //再重头遍历
            continue;
          }
        }
        //返回自动重命名的文件名称
        return newFileName;
      },
      //剪切文件
      cutFile() {
        //将数据放入剪切数组
        this.$store.commit("setCutArr", this.selectItemArr);
        this.$store.state.cutClonArr = Object.assign([], this.selectItemArr);
        //清空复制数组
        this.$store.commit("setCopyArr", []);
        this.$store.commit("setCutFolderId", this.$route.query.folderId);
        //关闭右键菜单
        this.rightMenuShow = false;
        this.pasteFlag = false;
        this.currentIndex = -1;
      },
      //复制文件
      copyFile() {
        //将数据放入复制数组
        this.$store.commit("setCopyArr", Object.assign([], this.selectItemArr));
        //清空剪切数据
        this.$store.commit("setCutArr", []);
        this.$store.commit("setCopyFolderId", this.$route.query.folderId);
        //关闭右键菜单
        this.rightMenuShow = false;
        this.pasteFlag = true;
        this.currentIndex = -1;
      },
      //粘贴文件
      pasteFile() {
        //判断是否是临时用户，然后提醒用户进行绑定邮箱
        let user = commonUtils.getUser();
        if (commonUtils.testUserIsTourist(user)) {
          this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
          this.$refs.remindBindEmailDialog.fromSign = 2;
          return false;
        }
        this.$store.state.catalogFileId = ''; //初始化选中文件夹值，防止刷新界面后还选中
        let cutData;
        let dataArr;
        let options;
        let operate; //用于标识用户是复制还是剪切操作
        let that = this;
        this.rightBlankMenuShow = false; //关闭右键菜单
        this.rightMenuShow = false;
        this.currentIndex = -1;
        let fromItem;
        let aimItem;
        let remove; //用于跨云盘传输标明是否是剪切
        let snapUser = commonUtils.getUser();
        that.$store.state.cancelAllFlag = false; //是的显示全部取消标志置为否
        //流量不足弹窗提醒
        let usedTraffic = snapUser.usedBytes;
        // if (snapUser.vip && snapUser.payLevel > 1) {
        //   usedTraffic = snapUser.payUsedTraffic;
        // }
        if (snapUser.totalBytes != -1 && usedTraffic >= snapUser.totalBytes) {
          this.$refs.upgradeDialog.upgradeShow = true;
          this.$refs.upgradeDialog.reset();
          this.$refs.upgradeDialog.trafficShow = true;
          return false;
        }
        //将即将要粘贴的数据赋值给dataArr
        if (this.$store.state.cutArr.length) {
          dataArr = Object.assign([], this.$store.state.cutArr);
          this.$store.state.cutClonArr = [];
        } else if (this.$store.state.copyArr.length) {
          dataArr = Object.assign([], this.$store.state.copyArr);
        }
        //将数据名称都放入nameArr
        let nameArr = [];
        if (this.tableData.length) {
          for (let i = 0; i < this.tableData.length; i++) {
            nameArr.push(this.tableData[i].name);
          }
        }
        if ((this.$refs.snapTaskDialog.items.length + dataArr.length) > 200) { //限制显示框不能超过200条
          let index = (this.$refs.snapTaskDialog.items.length + dataArr.length) - 200;
          dataArr.splice(dataArr.length - index, dataArr.length + 1);
          this.$toast({
            text: this.$t('language.cloudExploer.simultaneous'),
            type: 'fail',
            idValue: "rightBo",
            duration: 5000
          });
        }
        //如果是剪切状态的赋值
        if (that.$store.state.cutArr.length) {
          options = {
            isRemove: 1,
            isChar: 1,
            operate: 'cut'
          }
          remove = true;
          operate = 'cut';
          //如果是复制状态的赋值
        } else {
          options = {
            isRemove: 0,
            isChar: 1,
            operate: 'copy'
          }
          operate = 'copy'
        }
        //遍历即将粘贴的数据
        $.each(dataArr, function(index, sourceItem) {
          //若是跨云盘的传输
          if ((operate == 'copy' && (sourceItem.driveType == that.$route.query.cloudType) && commonstate
              .notSupportCopy.includes(that.$route.query.cloudType)) || (operate == 'cut' && (sourceItem
              .driveType == that.$route.query.cloudType) && commonstate.notSupportCut.includes(that.$route.query
              .cloudType)) || sourceItem.driveId != that.$route.query.tokenId) {
            //如果本地含有文件名，则弹窗提示进行选择，重命名或者跳过
            if (nameArr.includes(sourceItem.name)) {
              that.$refs.fileExistDialog.fileExistShow = true;
              that.$store.state.snapTaskShow = false;
              return false;
            }
          }
          //若将数据遍历完毕后
          if (index == dataArr.length - 1) {
            let aimJsonData;
            //用户执行一次paste操作，则封装则一组数据
            fromItem = taskTransferUtils.createTransferFromItems(dataArr);
            let Base64 = require('js-base64').Base64;
            //获取目标路径项
            if (localStorage.getItem("cloudExploerPaste")) {
              let cloudExploerPasteItems = JSON.parse(Base64.decode(localStorage.getItem("cloudExploerPaste")));
              if (cloudExploerPasteItems) {
                aimJsonData = cloudExploerPasteItems[that.$route.query.folderId];
                if (!aimJsonData) { //如果目标路径项为空则创建一个目标路径
                  aimJsonData = that.createAimItems();
                }
              } else {
                aimJsonData = that.createAimItems();
              }
            } else {
              aimJsonData = that.createAimItems();
            }
            //封装目标数据项
            aimItem = taskTransferUtils.createTransferFromItems([aimJsonData]);
            //1.如果是跨云盘的传输 2.如果是复制操作，是同云盘，但是不支持复制操作的
            //3.如果是剪切操作，是同云盘，但是不支持剪切操作的 4.是企业云盘不同子账号根目录的就是add接口
            //5.是wasabi不同桶的根目录的就是add接口
            var businessAddFlag = false;
            var wasabiAddFlag = false;
            if (fromItem[0].driveType == that.$route.query.cloudType) {
              if ((that.$route.query.cloudType == 'gSuite' || that.$route.query.cloudType == 'boxBusiness' || that
                  .$route.query.cloudType == 'oneDrive4Business') && that.$route.query.folderId.indexOf(":") != -
                1) {
                var args1 = that.$route.query.folderId.split(":");
                var userEmailId1 = args1[0];
                var args2 = fromItem[0].fileId.split(":");
                var userEmailId2 = args2[0];
                if (userEmailId1 != userEmailId2) {
                  businessAddFlag = true;
                }
              }
              if (that.$route.query.cloudType == 'dropbox4Business' && that.$route.query.folderId.indexOf(":") != -
                1) {
                var args1 = that.$route.query.folderId.split(":");
                if (args1[2]) {
                  var userEmailId1 = args1[2];
                  var args2 = fromItem[0].fileId.split(":");
                  var userEmailId2 = args2[2];
                  if (userEmailId1 != userEmailId2) {
                    businessAddFlag = true;
                  }
                }
              }
              //wasabi是不同桶之间复制则令wasabi AddFlag为true
              if (that.$route.query.cloudType == 'wasabi') {
                var args1 = fromItem[0].fileId.split("/");
                var forBucketName = args1[0];
                var args2 = aimItem[0].fileId.split("/");
                var toBucketName = args2[0];
                if (forBucketName != toBucketName) {
                  wasabiAddFlag = true;
                }
              }
            }
            if ((operate == 'copy' && (fromItem[0].driveType == that.$route.query.cloudType) && commonstate
                .notSupportCopy.includes(that.$route.query.cloudType)) || (operate == 'cut' && (fromItem[0]
                .driveType == that.$route.query.cloudType) && commonstate.notSupportCut.includes(that.$route.query
                .cloudType)) || fromItem[0].driveId != that.$route.query.tokenId || businessAddFlag ||
              wasabiAddFlag) {
              commonUtils.judgeNewDataFlag(that); //判断是否获进度度
              commonUtils.packageDetailData(fromItem, aimItem, remove); //把数据放在临时任务待执行弹窗
              if (that.$store.state.cutArr.length) { //复制完清空剪切数组
                that.$store.state.cutArr = [];
              }
              that.snapTaskIconShow = true; //显示临时任务列表弹窗
              that.$store.state.snapTaskShow = true;
              //请求后端add接口
              let addData = new taskTransferUtils.addTaskData(snapUser.id, 4, fromItem[fromItem.length - 1]
                .filename, fromItem, aimItem, options, null);
              that.Utils.doTasksRequest('add', addData).then(res => {
                that.$store.state.cancelAllFlag = true; //清空按钮置为显示
                if (res.status == 200) {
                  commonUtils.letFlagTrue(that); //让标志设置为true 并触发监听事件
                  commonUtils.packageHaveDataDetail(res.tasks);
                } else if (res.status == 400 && res.reason == 'permissionFail') {
                  commonUtils.removeDataDetail(addData);
                  that.$toast({
                    text: that.$t('language.exception.notPermission'),
                    type: 'fail',
                    idValue: "rightBo",
                    duration: 5000
                  });
                }
              });
            } else {
              //如果是同云盘的传输，显示临时任务列表弹窗
              that.snapTaskIconShow = true;
              that.$store.state.snapTaskShow = true;
              //显示清空标志
              that.$store.state.cancelAllFlag = true;
              commonUtils.judgePasteNewDataFlag(that); //判断是否该获取进度
              commonUtils.letFlagTrue(that); //让标志设置为true 并触发监听事件
              //若是除谷歌外同云盘传输 则调用paste/copy或者 cut接口
              $.each(dataArr, function(indexItem, Item) {
                cutData = new cloudExploerUtils.movePasteData(snapUser.id, Item.driveId, Item.pid, Item.id,
                  aimItem[0].fileId, Item.name, aimItem[0].nodes, Item.dir);
                that.$store.state.retryItems.push({
                  name: Item.name,
                  status: 'ready',
                  cutData: cutData,
                  operate: operate,
                  aimPid: Item.pid,
                  toDriveType: Item.driveType,
                  sharePath: Item.sharePath,
                  shareUrl: Item.shareUrl
                });
                if (indexItem == dataArr.length - 1) {
                  if (that.$store.state.cutArr.length) { //复制完清空剪切数组
                    that.$store.state.cutArr = [];
                  }
                }
              });
            }
          }
        });
      },
      //封装目标目录项
      createAimItems() {
        let aimJson = {};
        let that = this;
        let allCategory = this.$store.getters.getAllCategories;
        let cloud;
        $.each(allCategory, function(i, item) {
          if (item.appName == that.$route.query.cloudType) {
            cloud = item;
            aimJson.cloud = cloud;
            return false;
          }
        });
        aimJson.dir = true;
        aimJson.driveId = that.$route.query.tokenId;
        aimJson.driveType = that.$route.query.cloudType;
        aimJson.id = that.$route.query.folderId;
        aimJson.name = that.$route.query.folderName;
        if (that.pathJson.length > 1) {
          aimJson.pid = that.pathJson[that.pathJson.length - 2].id;
        } else {
          aimJson.pid = that.pathJson[0].id;
        }
        return aimJson;
      },
      //触发上传文件change事件
      clickUploadFileChange(event) {
        //判断是否是临时用户，然后提醒用户进行绑定邮箱
        let that = this;
        let user = commonUtils.getUser();
        if (commonUtils.testUserIsTourist(user)) {
          this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
          this.$refs.remindBindEmailDialog.fromSign = 3;
          if (that.$refs.uploadFile && that.$refs.uploadFile.value) {
            that.$refs.uploadFile.value = null;
          }
          return false;
        }
        let totalSize = 0;
        this.filesArr = [];
        let fileCount = event.target.files.length;
        $.each(event.target.files, function(i, item) {
          that.filesArr.push(item);
        });
        //计算总大小
        $.each(this.filesArr, function(i, item) {
          totalSize = totalSize + item.size;
          //总大小不能超多1G
          if (totalSize > 1024 * 1024 * 1024) {
            this.$toast({
              text: this.$t('language.cloudExploer.uploadSize'),
              type: 'fail',
              idValue: "rightBo"
            });
            that.filesArr.splice(i, 1);
            return false;
          }
        });
        //临时任务框总任务不能超过200条
        if ((this.$refs.snapTaskDialog.items.length + this.filesArr.length) > 200) {
          let index = (this.$refs.snapTaskDialog.items.length + this.filesArr.length) - 200;
          this.filesArr.splice(this.filesArr.length - index, this.filesArr.length + 1);
          this.$toast({
            text: this.$t('language.cloudExploer.simultaneous'),
            type: 'fail',
            idValue: "rightBo"
          });
        }
        //遍历文件长度，看是否有重复名
        for (let i = 0; i < this.filesArr.length; i++) {
          let uploadFileData = that.filesArr[i];
          var name = that.judgeRepeatUploadFileName(uploadFileData.name);
          let uploadData = new cloudExploerUtils.uploadData(commonUtils.getUser().id, that.$route.query.tokenId, that
            .$route.query.folderId, name);
          uploadData.upId = commonUtils.randomRangeId(10);
          that.$store.state.uploadArr.push({ //将数据放在待执行列表中
            name: name,
            percent: 0,
            status: 'ready',
            uploadData: uploadData,
            cloudType: that.$route.query.cloudType,
            uploadFileData: uploadFileData
          });
        }
        //上传列表置为空
        if (that.$refs.uploadFile && that.$refs.uploadFile.value) {
          that.$refs.uploadFile.value = null;
        }
        //显示临时任务窗口
        that.snapTaskIconShow = true;
        that.$store.state.snapTaskShow = true;
        that.$refs.snapTaskDialog.transferFlag = false;

        // 如果是sharedWithMe或者sharedDrive，检查上传权限
        if (this.$route.query.cloudType == 'google_drive_sharedWithMe' || this.$route.query.cloudType ==
          'gSuiteSharedDrive') {
          let uploadData = {
            dd: this.$route.query.tokenId,
            tid: this.$route.query.folderId,
            ud: commonUtils.getUser().id
          };
          requestUtils.doFilesRequest("upload.createSession", uploadData, {
            timeout: 1800000
          }).then(result => {
            requestUtils.doFilesRequest(result.upload_id + "/upload_check", uploadData, {
              timeout: 1800000
            }).then(res => {
              if (res.status == 401) {
                that.$toast({
                  text: that.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "rightBo"
                });
                for (var i = 0; i < fileCount; i++) {
                  that.$store.state.uploadArr.pop();
                }
              } else {
                //调用上传接口
                commonUtils.uploadFileChange();
              }
            });
          });
        } else {
          //调用上传接口
          commonUtils.uploadFileChange();
        }
      },
      //取消上传任务后的回调函数
      cancelUpload: function(data) {
        let that = this;
        if (commonstate.source) {
          commonstate.source.cancel('取消上传' + data);
        }
      },
      //去到回收站
      goTrash() {
        let id = 'recycle_bin' + this.$route.query.tokenId;
        let that = this;
        //关闭右侧的空白菜单
        this.rightBlankMenuShow = false;
        this.rightMenuShow = false;
        //如果缓存有回收站数据
        if (this.$store.state.cacheTableDatas[id]) {
          this.getPathJson(); //获取路径信息
          that.recycleBinShow = true; //回收站标志设为真
          this.tableData = this.$store.state.cacheTableDatas[id].tableData; //设置本界面数据为缓存数据
          this.nextPage = this.$store.state.cacheTableDatas[id].nextPage;
          //更改路由信息为回收站信息
          that.$router.push({
            name: "emailExploer",
            query: {
              cloudType: that.$route.query.cloudType,
              folderId: 'recycle_bin',
              folderName: 'recycle_bin',
              tokenId: that.$route.query.tokenId,
              docType: that.$route.query.docType,
              queryParameter: that.$route.query.queryParameter
            }
          });
        } else {
          //如果没有回收站的数据，则向后端发送请求
          this.trashRequest();
        }
      },
      //回收站数据请求
      trashRequest() {
        this.loading = true; //设置加载效果
        this.noMore = false;
        this.tableData = [];
        let that = this;
        let id = 'recycle_bin' + this.$route.query.tokenId;
        let recycleData = new cloudExploerUtils.recycleData(commonUtils.getUser().id, this.$route.query
          .tokenId); //封装请求数据
        this.Utils.doFilesRequest("recycle_bin", recycleData).then(res => { //发送请求
          if (res.status == 200) {
            that.loading = false; //取消加载效果
            that.recycleBinShow = true; //回收站设为真
            if (res.items) { //给返回数据封装类型，pid和云盘的id
              for (let i = 0; i < res.items.length; i++) {
                res.items[i].driveType = that.$route.query.cloudType;
                res.items[i].pid = recycleData.id;
                res.items[i].driveId = recycleData.dd;
              }
            }
            //更改路由信息为回收站信息
            that.$router.push({
              name: "emailExploer",
              query: {
                cloudType: that.$route.query.cloudType,
                folderId: 'recycle_bin',
                folderName: 'recycle_bin',
                tokenId: that.$route.query.tokenId,
                docType: that.$route.query.docType,
                queryParameter: that.$route.query.queryParameter
              }
            });
            //如果此时没有切换界面，则将值设为这个界面的
            if (that.$route.query.folderId == 'recycle_bin') {
              that.tableData = commonUtils.sortArr(res.items, this.upShow, this.index);
              that.$store.commit("setCacheTableDatas", {
                id: id,
                docType: that.docType,
                tableData: that.tableData,
                nextPage: that.nextPage
              });
            }
            //提交回收站路径信息
            this.commitRecycleBinPathData();
          } else {
            this.$toast({
              text: this.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBo"
            });
          }
        });
      },
      //没有加载效果的回收站数据请求
      trashRequestNoLoad() {
        let that = this;
        let id = 'recycle_bin' + this.$route.query.tokenId;
        let recycleData = new cloudExploerUtils.recycleData(commonUtils.getUser().id, this.$route.query.tokenId);
        this.Utils.doFilesRequest("recycle_bin", recycleData).then(res => {
          if (res.status == 200) {
            if (res.items) {
              for (let i = 0; i < res.items.length; i++) {
                res.items[i].driveType = that.$route.query.cloudType;
                res.items[i].pid = recycleData.id;
                res.items[i].driveId = recycleData.dd;
              }
            }
            if (that.$route.query.folderId == 'recycle_bin') {
              that.recycleBinShow = true;
              that.tableData = commonUtils.sortArr(res.items, this.upShow, this.index);
              that.$store.commit("setCacheTableDatas", {
                id: id,
                docType: that.docType,
                tableData: that.tableData,
                nextPage: that.nextPage
              });
            }
          } else {
            this.$toast({
              text: this.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "rightBo"
            });
          }
        });
      },
      //关闭所有的菜单信息
      closeAllMenu() {
        this.rightMenuShow = false;
        this.searchMenuShow = false;
        this.recycleMenuShow = false;
        this.rightBlankMenuShow = false;
      },
      //提交回收站路径信息
      commitRecycleBinPathData() {
        let that = this;
        let folderId = this.$route.query.folderId;
        let pathOne = that.pathJson[0];
        that.pathJson = [];
        //将此时的路径信息改为第一条路径信息+trash路径
        that.pathJson.push(pathOne);
        that.pathJson.push({
          id: 'recycle_bin',
          name: that.$t('language.cloudExploer.trash'),
          driveId: that.$route.query.tokenId,
        });
        //防止数据污染，克隆数据
        let JsonList = Object.assign([], that.pathJson);
        //将第一级路径存入路径缓存
        that.$store.commit("setPathJson", {
          folderId: pathOne.id + that.$route.query.tokenId,
          json: [pathOne]
        });
        //将加了trash的路径存入路径缓存
        that.$store.commit("setPathJson", {
          folderId: folderId + that.$route.query.tokenId,
          json: JsonList
        });
      },
      //跳转到主页
      toHomePage() {
        //选中主页菜单
        this.$parent.$refs.leftBanner.menuOptionSelect(10);
        //路由跳到主页
        this.$router.push({
          name: 'homePage'
        });
      },
      //是否显示新建菜单
      showNewFolder() {
        let flag;
        if (this.$route.query.cloudType == 'outlook' && !(this.$route.query.docType == 'thread')) {
          flag = true;
        }
        return flag;
      },
      // 判断folderId是否为sharePoint的站点子目录
      isSiteChild() {
        let flag = false;
        var folderId = this.$route.query.folderId;
        var nweId = folderId.split(':')[0];
        if (nweId == 'site') {
          flag = true;
        }
        return flag;
      },
      // 判断是否为SharePoint的根目录站点子目录（用于跳转到第三方站点且不影响其它云盘）
      isSiteRootOrChild() {
        let flag = true;
        return flag;
      },
      //导航栏只显示离线任务菜单，false为不显示，true为显示
      onlyShowRemote() {
        let flag = true;
        if (this.$route.query.cloudType == 'gmail' || this.$route.query.cloudType == 'outlook') {
          flag = false;
        }
        if (!this.$route.query.cloudType) {
          return;
        }
        return flag;
      },
      //显示上传文件菜单,false为不显示，true为显示
      showUploadFile() {
        let flag;
        if (this.$route.query.cloudType == 'gmail' || this.$route.query.cloudType == 'outlook') {
          flag = false;
        }
      
        return flag;
      },
      //显示剪切菜单,false为不显示，true为显示
      showCutMenu() {
        let flag = true;
        //根目录下这些名称的文件夹无法删除，剪切，粘贴
        if (this.$route.query.cloudType == 'gmail' && this.$route.query.folderId == 'root') {
          flag = false;
        }
        if (this.$route.query.cloudType == 'outlook' && this.$route.query.folderId == '/') {
          flag = false;
        }
        return flag;
      },
      //显示删除菜单，false为不显示，true为显示
      showDeleteMenu() {
        let flag = true;
        //根目录下这些名称的文件夹无法删除，剪切，粘贴
        if (this.$route.query.cloudType == 'gmail' && this.$route.query.folderId == 'root') {
          flag = false;
        }
        return flag;
      },
      //显示重命名菜单，false为不显示，true为显示
      showRenameMenu() {
        let flag;
        if (this.$route.query.cloudType == 'gmail') {
          flag = false;
        }
        return flag;
      },
      //显示粘贴菜单，false为不显示，true为显示
      showPasteMenu() {
        let flag = false;
        if (this.$route.query.cloudType == 'gmail') {
          flag = false;
        }
        return flag;
      },
      //看菜单长度是否超出了界面，如果超出了则显示more
      checkBoxWidth() {
        let that = this;
        let flag;
        let box = this.$refs.rightMiddle;
        let menuBotton = this.$refs.menuButton;
        if (box && menuBotton && box.clientWidth && menuBotton.clientWidth && (box.clientWidth - menuBotton
            .clientWidth) < 151) {
          that.moreShow = true;
        } else {
          that.moreShow = false;
        }
        that.$forceUpdate();
      },
      //右键菜单是否显示
      showSelectRightMenu() {
        let flag;
        if (this.rightMenuShow) {
          flag = true;
        }
        if ((this.$route.query.cloudType == 'gSuite' && this.$route.query.folderId == '/') || this.$route.query
          .folderId == 'recycle_bin') {
          flag = false;
        }
        if (this.$route.query.searchResult) {
          flag = false;
        } 
        if (this.$route.query.cloudType == 'sharePointOnline') {
          if (this.$route.query.folderId == 'root0' || this.isSiteChild())
            flag = false;
        }
        return flag;
      },
      //"复制到"菜单是否显示
      showCopyTo() {
        let flag = true;
        if (this.$route.query.cloudType == 'gmail' && this.$route.query.folderId == 'root') {
          flag = false;
        }
        if (this.$route.query.cloudType == 'outlook' && this.$route.query.folderId == '/') {
          flag = false;
        }
        return flag;
      },
      //复制菜单是否显示
      showCopy() {
        let flag = true;
        if (this.$route.query.cloudType == 'gmail' && this.$route.query.folderId == 'root') {
          flag = false;
        }
        if (this.$route.query.cloudType == 'outlook' && this.$route.query.folderId == '/') {
          flag = false;
        }
        return flag;
      },
      showDownLoad() {
        let flag = false;
        if(this.$route.query.cloudType=='gmail'&&this.selectItemArr[0].docType=='thread'){
          flag = true;
        }
        if(this.$route.query.cloudType=='outlook'){
          let isThreads = true;
          for (var i = 0; i <=  this.selectItemArr.length - 1; i++) {
            if ( this.selectItemArr[i].docType != "thread") {
              isThreads = false;
              break;
            }
          }
          if(isThreads){
            flag = true;
          }
        }
        return flag;
      },
      //未选中任何选项时出现的菜单
      itemButtonShow() {
        let flag;
        if (!this.selectItemArr.length && this.$route.query.cloudType == 'outlook') {
          flag = true;
        }
        return flag;
      },
      //显示清空回收站
      showEmptyTrash() { //只有googleDrive支持清空回收站
        let flag;
        return flag;
      },
      //是否显示导航栏菜单
      showMenuButton() {
        let flag = true;
        let that = this;
        if (!this.selectItemArr.length || this.searchResultShow) {
          flag = false;
        }
        return flag;
      },
      //获取普通界面右上按钮的宽度
      getWidth() {
        let result;
        if (this.$i18n.locale == 'english' || this.$i18n.locale == 'france' || this.$i18n.locale == 'spanish' || this
          .$i18n.locale == 'italian') {
          result = 110 + 'Px';
        }
        if (this.$i18n.locale == 'deutsch' || this.$i18n.locale == 'portuguese') {
          result = 125 + 'Px';
        }
        if (this.$i18n.locale == 'japanese') {
          result = 118 + 'Px';
        }
        if (this.$i18n.locale == 'traditionalChinese' || this.$i18n.locale == 'chinese') {
          result = 79 + 'Px';
        }
        return result;
      },
      //获取回收站右上按钮的宽度
      getTrashWidth() {
        let result;
        if (this.$i18n.locale == 'english') {
          result = 110 + 'Px';
        }
        if (this.$i18n.locale == 'deutsch' || this.$i18n.locale == 'spanish') {
          result = 160 + 'Px';
        }
        if (this.$i18n.locale == 'france') {
          result = 200 + 'Px';
        }
        if (this.$i18n.locale == 'portuguese' || this.$i18n.locale == 'italian') {
          result = 150 + 'Px';
        }
        if (this.$i18n.locale == 'chinese' || this.$i18n.locale == 'japanese' || this.$i18n.locale ==
          'traditionalChinese') {
          result = 100 + 'Px';
        }
        return result;
      },
      //获取各位语言文字的长度
      getTextWidth(index) {
        let result;
        if (this.$i18n.locale == 'english') {
          if (index == 13) {
            result = 70 + 'Px';
          }
          if (index == 5 || index == 4 || index == 11) {
            result = 60 + 'Px';
          }
          if (index == 3) {
            result = 50 + 'Px';
          }
          if (index == 1) {
            result = 75 + 'Px';
          }
          if (index == 2) {
            result = 80 + 'Px';
          }
          if (index == 6) {
            result = 105 + 'Px';
          }
          if (index == 7 || index == 8 || index == 9 || index == 10) {
            result = 71 + 'Px';
          }
          if (index == 12) {
            result = 90 + 'Px';
          }

        }
        if (this.$i18n.locale == 'deutsch') {
          if (index == 2 || index == 1) {
            result = 115 + 'Px';
          }
          if (index == 3) {
            result = 90 + 'Px';
          }
          if (index == 4 || index == 11) {
            result = 75 + 'Px';
          }
          if (index == 5) {
            result = 55 + 'Px';
          }
          if (index == 6) {
            result = 138 + 'Px';
          }
          if (index == 7) {
            result = 125 + 'Px';
          }
          if (index == 8) {
            result = 80 + 'Px';
          }
          if (index == 9 || index == 12) {
            result = 105 + 'Px';
          }
          if (index == 10) {
            result = 100 + 'Px';
          }
          if (index == 13) {
            result = 90 + 'Px';
          }
        }
        if (this.$i18n.locale == 'france') {
          if (index == 1 || index == 2) {
            result = 95 + 'Px';
          }
          if (index == 3 || index == 8 || index == 11) {
            result = 65 + 'Px';
          }
          if (index == 4 || index == 7 || index == 10 || index == 12) {
            result = 85 + 'Px';
          }
          if (index == 5) {
            result = 70 + 'Px';
          }
          if (index == 6) {
            result = 165 + 'Px';
          }
          if (index == 9) {
            result = 75 + 'Px';
          }
          if (index == 13) {
            result = 80 + 'Px';
          }
        }
        if (this.$i18n.locale == 'portuguese') {
          if (index == 1) {
            result = 95 + 'Px';
          }
          if (index == 2 || index == 3) {
            result = 60 + 'Px';
          }
          if (index == 4) {
            result = 65 + 'Px';
          }
          if (index == 5) {
            result = 50 + 'Px';
          }
          if (index == 6) {
            result = 140 + 'Px';
          }
          if (index == 7 || index == 8) {
            result = 115 + 'Px';
          }
          if (index == 9) {
            result = 110 + 'Px';
          }
          if (index == 10) {
            result = 85 + 'Px';
          }
          if (index == 11) {
            result = 60 + 'Px';
          }
          if (index == 12) {
            result = 105 + 'Px';
          }
          if (index == 13) {
            result = 105 + 'Px';
          }
        }
        if (this.$i18n.locale == 'japanese') {
          if (index == 1) {
            result = 72 + 'Px';
          }
          if (index == 2) {
            result = 99 + 'Px';
          }
          if (index == 3 || index == 6) {
            result = 75 + 'Px';
          }
          if (index == 4 || index == 5) {
            result = 46 + 'Px';
          }
          if (index == 7 || index == 9 || index == 11) {
            result = 65 + 'Px';
          }
          if (index == 8 || index == 10 || index == 12) {
            result = 88 + 'Px';
          }
          if (index == 13) {
            result = 60 + 'Px';
          }
        }
        if (this.$i18n.locale == 'traditionalChinese' || this.$i18n.locale == 'chinese') {
          if (index == 1 || index == 10) {
            result = 59 + 'Px';
          }
          if (index == 12 || index == 2 || index == 3 || index == 4 || index == 5 || index == 7 || index == 8 ||
            index == 9 || index == 11) {
            result = 46 + 'Px';
          }
          if (index == 6) {
            result = 75 + 'Px';
          }
          if (index == 13) {
            result = 60 + 'Px';
          }
        }
        if (this.$i18n.locale == 'spanish') {
          if (index == 1) {
            result = 72 + 'Px';
          }
          if (index == 2 || index == 10) {
            result = 80 + 'Px';
          }
          if (index == 3 || index == 11) {
            result = 60 + 'Px';
          }
          if (index == 5 || index == 4) {
            result = 65 + 'Px';
          }
          if (index == 6) {
            result = 135 + 'Px';
          }
          if (index == 7) {
            result = 75 + 'Px';
          }
          if (index == 8 || index == 9) {
            result = 93 + 'Px';
          }
          if (index == 12) {
            result = 85 + 'Px';
          }
          if (index == 13) {
            result = 87 + 'Px';
          }
        }
        if (this.$i18n.locale == 'italian') {
          if (index == 1) {
            result = 72 + 'Px';
          }
          if (index == 7 || index == 10) {
            result = 75 + 'Px';
          }
          if (index == 3 || index == 11) {
            result = 60 + 'Px';
          }
          if (index == 2 || index == 5 || index == 4) {
            result = 65 + 'Px';
          }
          if (index == 6) {
            result = 130 + 'Px';
          }
          if (index == 8 || index == 9) {
            result = 80 + 'Px';
          }
          if (index == 12) {
            result = 90 + 'Px';
          }
          if (index == 13) {
            result = 87 + 'Px';
          }
        }
        return result;
      },
      addActive($event) {
        if ($event.currentTarget.className.indexOf("button-border-right") != -1) {
          if ($event.currentTarget.className.indexOf("button-more") != -1) {
            $event.currentTarget.className = "single-button button-more button-border-right";
          } else {
            $event.currentTarget.className = "single-button button-border-right";
          }
        } else {

          if ($event.currentTarget.className.indexOf("button-more") != -1) {
            $event.currentTarget.className = "single-button button-more";
          } else {
            $event.currentTarget.className = "single-button";
          }
        }
      },
      removeActive($event) {
        if ($event.currentTarget.className.indexOf("button-border-right") != -1) {
          if ($event.currentTarget.className.indexOf("button-more") != -1) {
            $event.currentTarget.className = "single-button button-more button-border-right";
          } else {
            $event.currentTarget.className = "single-button button-border button-border-right";
          }
        } else {

          if ($event.currentTarget.className.indexOf("button-more") != -1) {
            $event.currentTarget.className = "single-button button-more";
          } else {
            $event.currentTarget.className = "single-button button-border";
          }
        }

      },
      haveForder(arr){
        //默认不含文件夹
        for (let i = 0; i < arr.length; i++) {
          if(arr[i].dir){
            return true;
          }
        }
        return false;
      },
      emailsFilter(value,myEmail) {
        if (!value) return '';
        let filterIndex = value.lastIndexOf(' <');
        if(filterIndex>0){
          let more = value.lastIndexOf(',');
          let str;
          if(more>0){
            //多个
            let vals = value.split(',');
            let newVakls = [];
            vals.forEach(v => {
              if(myEmail&&v.lastIndexOf(myEmail)>0){
                newVakls.push(this.$t('language.common.me'));
              }else{
                let fIndex = v.lastIndexOf(' <');
                if(fIndex>0){
                  let valsStr = v.substring(0,fIndex);
                  newVakls.push(valsStr);
                }else{
                  newVakls.push(v);
                }
              }
            });
            str = newVakls.join(',');
          }else{
            if(myEmail&&value.lastIndexOf(myEmail)>0){
              str = this.$t('language.common.me');
            }else{
              str = value.substring(0,filterIndex);
            }
          }
          return str;
        }else {
          return value;
        }
      }
    },
    filters: {
      //设置路径的过滤器
      ellipsisNavi(value) {
        let subStr;
        if (!value) return '';
        if (value.length > 126) {
          subStr = value.slice(0, 6) + '..' + value.slice(value.length - 6, value.length)
        } else {
          subStr = value;
        }
        return subStr;
      },
      fromFilter (value) {
        if (!value) return '';
        let filterIndex = value.lastIndexOf(' <');
        if(filterIndex>0){
          let more = value.lastIndexOf(',');
          let str;
          if(more>0){
            //多个
            let vals = value.split(',');
            let newVakls = [];
            vals.forEach(v => {
              let fIndex = v.lastIndexOf(' <');
              if(fIndex>0){
                let valsStr = v.substring(0,fIndex);
                newVakls.push(valsStr);
              }else{
                newVakls.push(v);
              }
            });
            str = newVakls.join(',');
          }else{
            str = value.substring(0,filterIndex);
          }
          return str;
        }else {
          return value;
        }
      },
    }
  };
</script>

<style>
  #tableBoxTitle .table-th:hover {
    cursor: pointer;
  }

  .more-white-position {
    position: relative !important;
    top: 4Px !important;
    margin-right: 5Px !important;
  }

  .more-botton-css {
    background-color: #5166BD;
    color: #fff;
    cursor: pointer;
    border-left: 1Px solid #ced7e5;
  }

  .more-botton-css:hover {
    background-color: #3250c9;
  }

  .more-botton-css:active {
    background-color: #5166BD;
  }

  .cut-position {
    width: 50Px;
  }

  .button-center-position {
    position: absolute;
    margin: auto;
    top: 5Px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  .button-content {
    vertical-align: middle;
    height: 30Px;
    width: 100%;
  }


  .home-icon-position {
    float: left;
    position: relative;
    top: 6px;
    /*no*/
    cursor: pointer;
  }

  .search-back {
    color: #687866;
    position: relative;
    top: 5px;
    /*no*/
    float: left;
  }

  .search-back:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .right-search-body {
    width: 100%;
    height: calc(100% - 40px);
    /*no*/
    float: left;
    background-color: #f2f7fe;
    position: relative;
  }

  #openFile {
    display: none;
  }

  .name-title {
    float: left;
    position: relative;
    top: 7px;
    /*no*/
  }

  .name-desc {
    float: left;
    position: relative;
    top: 5px;
    /*no*/
  }

  .add-Ellipsis {
    float: left;
    position: relative;
    top: 5px;
    /*no*/
  }

  .name-desc-one {
    float: left;
    position: relative;
  }

  .name-desc:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .text-bold {
    color: #000;
    font-weight: bold;
    position: relative;
    top: 5px;
    /*no*/
    float: left;
  }

  .navigation {
    height: 40%;
    width: calc(100% - 30px);
    /*no*/
    float: left;
  }

  .navigation-recycle {
    height: 40%;
    width: calc(100% - 30px);
    /*no*/
    float: left;
    position: relative;
    top: 5px;
    /*no*/
  }

  .menu-bar {
    width: 100%;
    height: 40px;
    /*no*/
    float: left;
  }

  .menu-bar-search {
    position: relative;
    top: 5px;
    /*no*/
  }

  .menu-bar-recycle {
    position: relative;
    top: -6px;
    /*no*/
    width: 140px;
    /*no*/
    float: right !important;
  }

  .triangle {
    height: 0;
    width: 0;
    overflow: hidden;
    font-size: 0;
    /*no*/
    line-height: 0;
    border-color: transparent transparent transparent #5562b4;
    border-style: solid dashed dashed dashed;
    border-width: 4px;
    /*no*/
  }

  .triangle-position {
    position: relative;
    left: 75px;
    /*no*/
    top: 11px;
    /*no*/
    margin: 0;
    float: left;
  }

  /*定义滑块，内阴影及圆角*/
  #tableBox::-webkit-scrollbar,
  #fileGrid::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 10Px;
    /* 给滚动条一个最小的高度 */
    background-color: #fff;
  }

  #tableBox::-webkit-scrollbar-thumb,
  #fileGrid::-webkit-scrollbar-thumb {
    min-height: 40px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
  }

  .name-cancel-position {
    margin-right: 5px;
    /*no*/
  }

  #tableBoxTitle {
    width: 100%;
    float: left;
    height: 40px;
    /*no*/
  }

  .cloud-td-one {
    width: 60%;
    cursor: pointer;
  }

  .cloud-td-oneDiv {
    width: 69%;
    float: left;
    height: 40Px;
  }

  .cloud-td-twoDiv {
    width: 15%;
    float: left;
    height: 40Px;
    text-align: left;
    white-space: nowrap;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
  }

  #fileGrid {
    width: 100%;
    float: left;
    height: calc(100% - 40Px);
    /* overflow: auto; */
    position: relative;
    text-align: center;
  }

  .cloud-td-one:hover {
    cursor: pointer;
  }

  .exploer-notice {
    position: absolute;
    bottom: 0;
    top: -20%;
    width: 100%;
    height: 20Px;
    margin: auto;
    text-align: center;
    font-size: 20Px;
    font-weight: 200;
  }

  .exploer-notice-two {
    position: absolute;
    bottom: 0;
    top: -12.5%;
    width: 100%;
    height: 20Px;
    margin: auto;
    text-align: center;
    font-size: 20Px;
    font-weight: 200;
  }

  .cloud-td-two {
    width: 15%;
    text-align: left;
    cursor: pointer;
  }

  .cloud-td-two:hover {
    cursor: pointer;
  }

  .tr-check-box {
    width: 55px;
    /*no*/
    height: 40px;
    /*no*/
    float: left;
    position: relative;
    cursor: pointer;
  }

  .tr-check-search {
    float: left;
    width: 15px;
    /*no*/
    height: 40px;
    /*no*/
    position: relative;
  }

  #tableBox {
    width: 100%;
    float: left;
    height: calc(100% - 40px);
    /*no*/
    /* overflow-y: overlay;
    overflow-x: hidden; */
    position: relative;

  }

  .file-position {
    float: left;
    margin-right: 20px;
    /*no*/
  }

  .add-plus-position {
    position: relative;
    margin-left: 5Px;
    top: 1Px;
  }

  .right-middle-search {
    height: 40px;
    /*no*/
    width: 100%;
    float: left;
    background-color: #f2f7fe;
    box-sizing: border-box;
    padding: 0% 2% 0% 2%;
    position: relative;
  }

  .navigation-path {
    font-size: 14px;
    /*no*/
    color: #687886;
    word-break: keep-all;
    white-space: nowrap;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 30px;
    /*no*/
  }

  #dropTableBox .table-tr {
    height: 40px;
    /*no*/
    color: #6f7886;
    font-size: 14px;
    /*no*/
    line-height: 40px;
    /*no*/
  }

  #navigation {
    height: 40px;
    /*no*/
    position: relative;
  }

  #navigation table {
    width: auto;
    table-layout: fixed;
  }

  #navigation table td {
    word-break: keep-all;
    white-space: nowrap;
  }

  .separate_icon {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -493px -201px;
    /*no*/
  }

  .menu-button {
    position: relative;
    top: 3%;
    height: 30px;
    /*no*/
    float: left;
  }

  .plus-position {
    float: left;
    position: relative;
    left: -2px;
    /*no*/
    margin-right: 15px;
    /*no*/
    top: 4px;
    /*no*/
  }


  .cloud-exploer-operating {
    position: relative;
    float: left;
    line-height: 22Px;
  }

  .button-content:hover .cloud-exploer-operating {
    color: #fff !important;
  }

  .cloud-exploer-more {
    float: left;
    position: relative;
    line-height: 22Px;
  }

  .more-position {
    float: left;
    position: relative;
  }

  .icon-position {
    float: left;
    position: relative;
  }

  .upload-file {
    height: 20px;
    /*no*/
    float: left;
    color: #4350a2;
  }

  .new-folder {
    height: 20px;
    /*no*/
    border-left: 1px solid #cdddf5;
    /*no*/
    float: left;
    color: #4350a2;
  }

  .new-folder-dis {
    height: 20px;
    /*no*/
    float: left;
    color: #4350a2;
  }

  .item-button {
    height: 20px;
    /*no*/
    font-size: 13px;
    /*no*/
    position: relative;
    top: 15%;
    float: left;
  }



  .upload-item {
    position: relative;
    top: 4px;
    /*no*/
    left: 5px;
    /*no*/
    float: left;
    line-height: 14Px;
    cursor: pointer;
  }


  .upload-item-dis {
    position: relative;
    top: 4px;
    /*no*/
    left: 5px;
    /*no*/
    float: left;
    line-height: 14Px;
    margin-right: 10Px;
  }

  .upload-item:hover {
    text-decoration: underline #4350a2;
  }

  .upload-item:active {
    text-decoration: none;
  }

  .folder-item:hover {
    text-decoration: underline #4350a2;
  }

  .folder-item-not,
  .folder-item-not:hover {
    color: #808080;
    pointer-events: none;
    position: relative;
    top: 4px;
    /*no*/
    float: left;
    line-height: 14Px;
    margin-right: 10Px;
  }

  .grid-icon-positon {
    position: relative;
    top: 7px;
    /*no*/
    left: 8px;
    /*no*/
    float: left;
    width: 15Px;
    height: 15Px;
  }

  .dropdown-position {
    position: relative;
    top: -4px;
    /*no*/
    left: 5px;
    /*no*/
    float: left;
    margin-right: 10px;
    /*no*/
  }

  .item-plus {
    position: relative;
    left: 10px;
    /*no*/
    width: 100%;
    /*no*/
  }

  .folder-item {
    position: relative;
    top: 4px;
    /*no*/
    float: left;
    line-height: 14Px;
    margin-right: 10Px;
    cursor: pointer;
  }

  .up-paste-position {
    float: left;
  }

  .cloud-paste-position {
    margin-left: 5Px;
  }

  .left-paste-position {
    position: relative;
    margin-left: 5Px;
    margin-right: 1Px;
  }


  .cloud-exploer-refresh:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 58%;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 600;
    white-space: nowrap;

  }

  .search:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 600;
    white-space: nowrap;
  }

  .list:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 95px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 600;
    white-space: nowrap;
  }

  .grid:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 95px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 3;
  }

  .separate_icon-position {
    float: left;
  }

  .refresh-position {
    margin-left: 10px;
    /*no*/
    float: right;
  }

  .operate-icons {
    float: right;
    width: 145px;
    /*no*/
    height: 20px;
    /*no*/
    position: relative;
    top: 17%;

  }

  .upload-file-items-choose {
    width: 100%;
    min-width: 94px;
    /*no*/
    height: 34px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    background: #fff;
    position: absolute;
    top: 20px;
    /*no*/
    z-index: 1;
  }

  .upload-file-item-choose {
    width: 100%;
    height: 34Px;
    line-height: 34Px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    margin-right: 15Px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .upload-file-item-choose:hover {
    background-color: #ebf3fe;
    color: #4181ff;
  }

  .tr-back-ground,
  .selecting,
  .selected {
    background: #ebf3fe !important;
  }

  .table-tr-hover {
    background: #ebf3fe !important;
  }

  .selection {
    border: 1Px dashed #000;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    display: none;
  }

  .remote-task-position {
    float: left;
    margin-right: 15px;
    /*no*/
    position: relative;
    top: 5px;
    /*no*/
    left: 2px;
    /*no*/
  }

  .more-item-children {
    display: none;
    width: 180px;
    /*no*/
    height: 60px;
    /*no*/
    background: #fff;
    position: absolute;
    z-index: 3;
    left: 180px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
  }

  .third-children {
    display: none;
    width: 180px;
    /*no*/
    height: 60px;
    /*no*/
    background: #fff;
    position: absolute;
    z-index: 3;
    left: 180px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
  }

  #sec:hover #twoChild {
    display: block;
  }

  #moreItem:hover #thirdChild {
    display: block;
  }

  .th-span {
    position: relative;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
  }

  .separate-icon-position {
    float: left;
  }

  .menu-txt {
    float: left;
  }

  .narrow-position-two {
    position: relative;
    top: 2Px;
  }

  .narrow-position {
    position: relative;
    top: 2Px;
  }

  .narrow-position:hover {
    cursor: pointer;
  }

  .right-body-disable {
    cursor: default;
    pointer-events: none;
  }

  .load-tr {
    text-align: center;
    font-size: 16Px;
    color: #6f7886;
    line-height: 40Px;
    height: 40Px;
    width: 100%;
    position: relative;
  }

  .load-tr-grid {
    text-align: center;
    font-size: 16Px;
    color: #6f7886;
    line-height: 40Px;
    height: 40Px;
    width: 100%;
    position: relative;
    float: left;
  }

  .single-button:hover .copy-to {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Copy_to_white.svg");
  }

  .single-button:hover .down-load {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_download_white.svg");
  }

  .single-button:hover .button-border:before {
    content: "";
    position: absolute;
    width: 1Px;
    height: 15Px;
    background-color: #4181ff !important;
    left: 0;
    top: 8Px;
  }

  .single-button:hover .share {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Share_white.svg");
  }

  .single-button:hover .cut {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Cut.svg");
    filter: drop-shadow(#fff 80px 0);
    /*no*/
    transform: translateX(-80px);
    /*no*/
  }

  .single-button:hover .delete {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Remove.svg");
    filter: drop-shadow(#fff 80px 0);
    /*no*/
    transform: translateX(-80px);
    /*no*/
  }

  .single-button:hover .preview {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Preview_white.svg");
    position: relative;
    top: 5Px;
  }

  .single-button:hover .encrypt {
    width: 13px;
    /*no*/
    height: 13px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Decrypt_white.svg");
    background-repeat: no-repeat;
  }

  .single-button:hover .copy {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Copy_white.svg");
  }

  .single-button:hover .to-site {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_go_toWhite.svg");
  }

  .single-button:hover .rename {
    width: 12px;
    /*no*/
    height: 10px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_renameWhite.svg");
    background-repeat: no-repeat;
  }

  .button-border-left {
    border-left: 1Px solid #ced7e5;
  }

  .button-border-right {
    border-right: 1Px solid #ced7e5;
  }

  .single-button:hover .more {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_moreWhite.svg");

  }

  .button-more:hover .preview,
  .more:hover .preview {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Preview.svg");
    position: relative;
    top: 5Px;
  }

  .button-more:hover .more-items-choose .share,
  .more:hover .share {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Share.svg");
  }

  .button-more:hover .rename,
  .more:hover .rename {
    width: 12px;
    /*no*/
    height: 10px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_rename.svg");
    background-repeat: no-repeat;
  }

  .button-more:hover .copy,
  .more:hover .copy {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Copy.svg");
  }

  .button-more:hover .to-site,
  .more:hover .to-site {
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_go_to.svg");
  }

  .grid-position-top {
    top: 10Px !important;
  }

  .grid-name-txt {
    position: relative;
    font-size: 12Px;
    color: rgb(189, 189, 189);
  }

#shareRightMenu .more-item-choose {
  min-width: 200Px;
  width: max-content;
}

  .share-position {
    float: right;
    position: relative !important;
    top: 10Px;
  }

  .button-more:hover .arrow-on {
    filter: drop-shadow(#fff 80px 0);
    /*no*/
    transform: translateX(-80px);
    /*no*/
  }

  .button-more:hover .arrow-down {
    filter: drop-shadow(#fff 80px 0);
    /*no*/
    transform: translateX(-80px);
    /*no*/
  }

  .subject-tip {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 2%;
  }

  .subject-tip span{
    color: #A3ADBD;
  }

  .email-preview .el-scrollbar .el-scrollbar__wrap {
    margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/email_exploer.vue